export default{
    "id": "aqoonsi",
    "dashboard": "Dashboard-ka",
    "warning": "Digniin",
    "users": "Isticmaalayaasha",
    "farms": "Beeraha",
    "animals": "Xoolaha",
    "action": "Ficil",
    "actionList": "Liiska Waxqabadka",
    "drugInventory": "Liiska Dawooyinka",
    "inseminatorStatistics": "Tirakoobka Inseminator",
    "organizationNTR": "Ururka NTR",
    "genotypePerformance": "Waxqabadka Genotype",
    "semenAutomation": "Shahwada Automation",
    "activityLogs": "Diiwaanka Hawlaha",
    "username": "Magaca isticmaalaha",
    "title": "Ciwaanka",
    "deactivated": "Demiyey",
    "name": "Magaca",
    "email": "iimaylka",
    "emailAddress": "Cinwaanka emailka",
    "mobileNum": "Nambarka taleefonka",
    "emailOrMobile": "Email/Mobile",
    "role": "Doorka",
    "roles": "Doorarka",
    "department": "Waaxda",
    "status": "Xaalada",
    "pages": "Bogagga",
    "departments": "Waaxyaha",
    "password": "Furaha",
    "cancel": "Jooji",
    "submit": "Gudbi",
    "error": "qalad",
    "success": "guul",
    "Browse": "baadh",
    "orDropYourFileCsvXlsXlsxHere": "ama ku rid faylkaaga (CSV, XLS, XLSx) halkan",
    "search": "Raadi",
    "apply": "Codso",
    "select": "Dooro",
    "previous": "Hore",
    "mandatory": "Waa qasab",
    "dropYourFileHere": "ama ku rid faylkaaga (CSV, XLS, XLSx, PDF,Docx,PNG,JPEG) halkan",
    "restoreDefault": "Soo Celinta Defaalka",
    "pending": "La sugayo",
    "completed": "Dhammaystiran",
    "remove": "Ka saar",
    "update": "Cusbooneysii",
    "removeFile": "Ka saar Faylka",
    "uploadFile": "Soo rar faylka",
    "pleaseChoosePreferedLanguage": "Fadlan door luqadda aad door bidayso",
    "edit": "Wax ka beddel",
    "activate": "Daar",
    "deactivate": "Dami",
    "recievedOrders": "Dalabka la helay",
    "chartRepresentation": "Matalaadda Shaxda",
    "nameIsRequired": "Magaca ayaa loo baahan yahay",
    "export": "Dhoofinta",
    "noFilesAvailable": "FAylal aan la heli karin",
    "selectDepartmentToshowRoles": "Dooro waax si aad doorar u muujiso",
    "selectDepartmentWithActiveRoles": "Dooro waax leh door firfircoon",
    "nameCanContainOnlyAlphabets": "Magaca waxa uu ka koobnaan karaa alifbeetada kaliya",
    "nameMustBeLessThan15Chars": "Magaca waa in uu ka yar yahay 30 xaraf",
    "emailRequired": "Iimayl ayaa loo baahan yahay",
    "invalidEmailFormat": "Qaab iimaylka aan ansax ahayn",
    "mobNumReq": "Nambarka gacanta ayaa loo baahan yahay",
    "invalidMobFormat": "Qaabka lambarka mobaylka aan ansax ahayn.",
    "passwordRequired": "Furaha sirta ah ayaa loo baahan yahay",
    "departmentReq": "Waax ayaa loo baahan yahay",
    "roleReq": "Door ayaa loo baahan yahay",
    "unableToUpdate": "Lama cusbooneysiin karo",
    "orignalName": "Magaca asalka ah",
    "uploadedDate": "Taariikhda la soo galiyay",
    "fileName": "Magaca faylka",
    "importNum": "Lambarka soo dejinta",
    "languagePreferences": "Doorbida Luuqadda",
    "pleaseTryAgainAfterSometime": "Fadlan isku day wakhti ka dib",
    "noChanges": "Isbadal Ma Jiro",
    "nothingchanged": "Wax isma bedelin",
    "pleaseChooseAnImageFile": "Fadlan dooro faylka sawirka",
    "fileIsTooBigSelectUnder1MB": "Faylkaagu aad buu u weyn yahay! ",
    "phoneShouldHave10Chars": "Taleefanka waa inuu lahaadaa 10 xaraf",
    "onlyCSVAllowed": "Kaliya faylka CSV ayaa la oggol yahay",
    "loadingPleaseWait": "Soodejinaya... Fadlan sug",
    "manager": "maamulaha",
    "administrator": "maamule",
    "Comingsoon": "Goordhow imaanaya",
    "totalAnimals": "Wadarta Xoolaha",
    "receivedOrders": "Dalabka la helay",
    "drugs": "Daawooyinka",
    "detailedAnalysis": "Falanqaynta faahfaahsan",
    "barGraphRepOfActiveUsersAndDeactivateUsers": "Matalaadda Sawirka Bar ee Isticmaalayaasha Firfircoon iyo Isticmaalayaasha Fadhiidka ah",
    "barGraphRepOfRegAnimalsVsFarm": "Bar Graph Matalaadda Xayawaanka Diiwaangashan Vs Beerta",
    "roleNumber": "Lambarka doorka",
    "roleName": "Magaca doorka",
    "active": "Firfircoon",
    "inactive": "Firfircoonayn",
    "admin": "Admin",
    "addRole": "Doorka ku dar",
    "addRoles": "Ku dar doorarka",
    "permissions": "Ogolaanshaha",
    "sr": "Sr.",
    "moduleName": "Magaca Module",
    "view": "Daawo",
    "deptNo": "Waaxda No.",
    "selectByCategory": "Dooro Qayb ahaan",
    "weeklyAnalytics": "Falanqaynta toddobaadlaha ah",
    "pregnancy": "Uurka",
    "analytics": "Falanqaynta",
    "calendar": "Kalandarka",
    "productName": "Magaca Alaabta",
    "volumeSold": "Mugga la iibiyay",
    "recordPoints": "Dhibcaha Diiwaangelinta",
    "inStock": "In Stock",
    "revenue": "Dakhliga",
    "stockStatus": "Heerka Saamiyada",
    "barChart": "Shaxda Bar",
    "lineChart": "Shaxda khadka",
    "indexReturns": "Soo Celinta Tusmada",
    "chart": "Shaxda",
    "time": "waqti",
    "production": "Wax soo saar",
    "customization": "Habaynta",
    "recordsPerPage": "Diiwaanada bog kasta",
    "noDataAvailable": "Xog lama heli karo",
    "reporting": "Ka warbixinta",
    "optional": "Ikhtiyaar ah",
    "note": "Ogow",
    "notes": "Xusuusin",
    "date": "Taariikhda",
    "kG": "KG",
    "weight": "miisaanka",
    "type": "Nooca",
    "lessthan3Month": "<3 Bilood",
    "lessthan6Month": "<6 Bilood",
    "lessthan7Month": "<7 Bilood",
    "lastWeek": "Toddobaadkii hore",
    "thisWeek": "Isbuucaan",
    "lessthanOneYear": "<1 sano",
    "lessthanTwoYear": "<2 sano",
    "lessthanThreeYear": "<3 sano",
    "lessthanFourYear": "<4 Sano",
    "yes": "Haa",
    "no": "Maya",
    "of": "ee",
    "notSpecified": "Oo aan lagu cayimin",
    "days": "maalmo",
    "day": "maalin",
    "aDay": "maalin",
    "years": "sanado",
    "year": "sanad",
    "unit": "unug",
    "units": "Unugyo",
    "to": "ku",
    "profile": "Profile",
    "logOut": "Ka bax",
    "Unit": "Unug",
    "otherSettings": "Dejinta Kale",
    "somethingWentWrong": "waxbaa qaldamay.",
    "toDo": "In la Sameeyo",
    "loadingData": "Soodejinaya xogta...",
    "taskNumber": "Lambarka Hawsha",
    "taskName": "Magaca Hawsha",
    "startDate": "Taariikhda billowga",
    "dueDate": "Taariikhda la filayo",
    "reason": "Sababta",
    "quantity": "Tirada",
    "cost": "Qiimaha",
    "noRecordFound": "Wax Diiwaan ah lama helin",
    "dailyUpdates": "Cusbooneysiin maalinle ah",
    "weeklyUpdates": "Cusbooneysii Todobaadle",
    "moduleAccessed": "Module waa la galay",
    "typesOfAccess": "Noocyada Helitaanka",
    "userId": "UserId",
    "lastLogin": "Gelidii u dambaysay",
    "terminalID": "Aqoonsiga Terminalka",
    "geographicalAccessPoint": "Barta Galitaanka Juqraafiyeed",
    "iPAddress": "Cinwaanka IP-ga",
    "fileAccessed": "Faylka waa la helay",
    "functionAccessed": "Shaqada la helay",
    "webPageURL": "URL bogga shabakadda",
    "accessType": "Nooca Helitaanka",
    "unsuccessfulLoginAttempts": "Isku-dayga Galitaanka ee aan guulaysan",
    "customerAddress": "Cinwaanka Macmiilka",
    "orderdate": "Taariikhda Dalbashada",
    "postageDate": "Taariikhda Boostada",
    "postID": "Aqoonsiga boostada",
    "packingTechnician": "Farsamo-yaqaanka wax-baakaynta",
    "packingTechnicia": "Farsamada Baakadaha",
    "packEdit": "Baakad Wax ka beddel",
    "batchNumber": "Lambarka Dufcada",
    "collectionTechnician": "Farsamo-yaqaanka Ururinta",
    "collectionTechnicia": "Farsamada Ururinta",
    "preparationTechnicia": "Farsamada Diyaarinta",
    "preparationTechnician": "Farsamada Diyaarinta",
    "approvedManually": "Gacanta lagu ansixiyay",
    "researcher": "Cilmi baare",
    "dateOfApproval": "Taariikhda Ansixinta",
    "approvalEdit": "Wax ka beddelka ansixinta",
    "searchByAllExceptDate": "Ku baadh Dhammaan marka laga reebo Taariikhda",
    "approval": "Ansixinta",
    "collection": "Ururinta",
    "postage": "Boostada",
    "pack": "Xirmo",
    "straws": "Caws",
    "createdAt": "Waxa la sameeyay",
    "sireID": "Aqoonsiga Sirta",
    "economicIndexValue": "Qiimaha Tilmaanta Dhaqaalaha",
    "latestCollectionDate": "Taariikhda Ururinta Ugu Danbaysa",
    "locationId": "Goobta Aqoonsiga",
    "lastUpdated": "La cusbooneysiiyay",
    "print": "Daabac",
    "save": "Badbaadin",
    "tax": "Canshuur",
    "phoneNo": "Taleefanka No",
    "exportAsPDF": "U dhoofi sidii PDF",
    "statusUpdated": "Xaalada waa la cusboonaysiiyay",
    "statusNotUpdated": "Xaalada Aan La cusboonaysiin",
    "inProgress": "Horumarka",
    "assignedTo": "Loo xilsaaray",
    "taskId": "Shaqada id",
    "createdDate": "Taariikhda la sameeyay",
    "numberOfAnimals": "Tirada Xoolaha",
    "healthRecordSubmittedSuccess": "Diiwaanka Caafimaadka Si guul leh ayaa loo soo gudbiyay",
    "healthRecordSubmitted": "Diiwaanka Caafimaadka Waa La Soo Gudbiyey.",
    "InseminationRecordSubmittedSuccesful": "Diiwaanka dhalmada ayaa la soo gudbiyay si guul leh",
    "inseminationRecordSubmitted": "Diiwaanka dhalmada waa la gudbiyay.",
    "actionListDailyTask": "Liiska Waxqabadka - Hawsha Maalinlaha ah",
    "sinceLastYear": "Tan iyo Sannadkii hore",
    "sinceLastQuarter": "Tan iyo rubuci ugu dambeeyay",
    "sinceLastMonth": "Ilaa bishii hore",
    "sinceLastWeek": "Ilaa Usbuucii hore",
    "drugWithdrawPeriod": "Muddada ka bixida daroogada",
    "diagnosisName": "Magaca ogaanshaha",
    "animalWithNoGenetype": "Xayawaankan ma hayo wax xog ah oo Genotype diiwaan gashan. ",
    "nameOfPreviousOwner": "Magaca Mulkiilihii Hore",
    "avatarSize": "Cabbirka avatarku waa inuu ka yaraado 1 MB!",
    "testDestination": "Tijaabi Meesha",
    "animalNotAdded": "Xoolaha Laguma Darin",
    "registerationSuccessful": "Diiwangelintii Lagu Guulaystay",
    "backToAnimalList": "Ku laabo Liiska Xoolaha",
    "addAnotherAnimal": "Ku dar xayawaan kale",
    "animalDetailsUpdated": "Faahfaahinta xayawaanka si guul leh ayaa loo cusboonaysiiyay",
    "animalUpdatedSuccessfully": "Xoolaha si guul ah loo cusboonaysiiyay",
    "animalNotUpdated": "Xayawaanka lama cusbooneysiin",
    "notMember": "Ma aha xubin?",
    "requestAccess": "Codso galaangal",
    "typePassword": "Fadlan ku qor erayga sirta ah",
    "minChars": "ugu yaraan 6 xaraf",
    "typeConfirmPassword": "ku qor xaqiijinta erayga sirta ah",
    "passConfig": "Xaqiijinta sirta ah kuma habboona",
    "invalidEmailMobile": "Qaabka iimaylka/mobile aan sax ahayn",
    "passwordNotEmpty": "Furaha sirta ah ma noqon karo madhan",
    "passwordLength": "Dhererka erayga sirta ah kama yaraan karo 8 xaraf",
    "cityVillage": "Magaalada / Tuulada",
    "districtRegion": "Degmo/Goboleed",
    "alreadyHaveAnAccount": "Horey akoon u leedahay?",
    "genetypeUpdated": "GenoType waa la cusbooneysiiyay",
    "genetypeNotUpdated": "GenoType lama cusbooneysiin",
    "sellTrade": "Iibi/Ganacsi",
    "milkingDevon": "Kaydka Taranka ee Devon ee iibka ah",
    "detailedDescription": "Sharaxaad faahfaahsan",
    "longPara": "Milking American Devon Bulls lo'da iyo lo'da. ",
    "contactSeller": "La xidhiidh Iibiyaha",
    "enterListingTitle": "Geli Cinwaanka Liiska",
    "livestocktype": "Nooca Xoolaha",
    "uploadImage": "Soo rar Sawir",
    "mobilePhone": "Lambarka Mobilka",
    "myLivestock": "Xoolahayga",
    "livestockObservations": "Indho-indheynta Xoolaha",
    "selectFromRegisteredAnimals": "Ka Dooro Liiska Xayawaanka Diiwaangashan",
    "selectOption": "Dooro Ikhtiyaar",
    "selectTypeObservation": "Dooro Nooca Kormeerka",
    "attachVeteinaryDocument": "Ku lifaaq dukumeentiga caafimaadka xoolaha",
    "addsensorReading": "Kudar Akhriska Dareemaha",
    "myDocument": "Dukumentiyadayda",
    "enterAKeyword": "Geli kelmad furaha",
    "documentType": "Nooca dukumeentiga",
    "registerEditLivestock": "Diiwaangeli/wax ka beddel Xoolaha",
    "editLivestockProfile": "Wax ka beddel xogta xoolaha",
    "copy": "Nuqul",
    "dateOfRegister": "Taariikhda Diiwangelinta",
    "livestockType": "Nooca Xoolaha",
    "registerNewLivestock": "Diiwaangelinta Xoolaha Cusub",
    "enterUniqueTag": "Geli Tag Gaar ah",
    "color": "Midabka",
    "gender": "Jinsiga",
    "male": "Lab",
    "female": "Dheddig",
    "damm": "Biyo-xidheenka",
    "siree": "Sirdoon",
    "dateOfSaleAuction": "Taariikhda Iibka/Iibka Xaraashka",
    "auctionRecord": "Diiwaanka Xaraashka ee Liiska Dhimashada",
    "distinguishingFeatures": "Tilmaamaha Kala soocida",
    "keywordListing": "Kelmad furaha ama aqoonsiga liiska",
    "adType": "Nooca Xayeysiiska",
    "activeListingFund": "1 Liis Firfircoon Oo La Helay",
    "setupSensors": "Samee Dareemayaasha",
    "serialNumber": "Nambarada taxan",
    "sensorLocation": "Goobta Dareemaha",
    "sensorType": "Nooca Sensor",
    "installationDate": "Taariikhda Rakibaadda",
    "ExpirationDate": "Taariikhda uu dhacayo",
    "addGeo": "Kudar Gelocation",
    "addMoreSensors": "Ku dar Dareemayaal badan",
    "trackAndTrace": "Raad raac oo Raad raac",
    "createNewShipment": "Samee Shixnad Cusub",
    "workflowReference": "Tixraaca Socodka Shaqada",
    "invoiceDate": "Taariikhda qaansheegta",
    "trackShipment": "Raad-raac Shixnadaha",
    "totalShipments": "Wadarta shixnadaha",
    "activeShipment": "Shixnadaha Firfircoon",
    "completedObjectives": "Ujeedooyinka Dhamaystiran",
    "processedPayments": "Lacagaha la habeeyey",
    "pointOfDestination": "Meesha loo socdo",
    "sellerInformation": "Macluumaadka Iibiyaha",
    "selectSellerConsignor": "Dooro Iibiyaha/Qaybta",
    "pointOfOrigin": "Halka uu ka soo jeedo",
    "buyerInfo": "Macluumaadka iibsadaha",
    "selectBuyerConsignor": "Dooro Iibsad/Khaye",
    "addSensorTriggers": "Ku dar Dareemaha Kiciyeyaasha",
    "processPayments": "Habka Lacag bixinta",
    "defineShippingContract": "Qeex Heshiiska Rarida",
    "addDigitize": "Ku darso",
    "currentlyOnFarm": "Hadda ku yaal Beerta",
    "addSire": "Kudar Sire",
    "addApproval": "Ku dar Ansixinta",
    "addCollection": "Ku dar Ururinta",
    "addStraws": "Caws ku dar",
    "addPack": "Kudar Xidhmada",
    "addPostage": "Kudar Boostada",
    "searchBySire": "Search By Sire",
    "anyDataChangeMightBeLost": "Isbeddel kasta oo xog ah ayaa laga yaabaa inuu lumo",
    "wouldYouLikeToSaveOrWantToLeaveWithoutSaving": "Ma jeclaan lahayd inaad kaydiso ama aad rabto inaad baxdo adigoon waxba kaydsan",
    "leave": "Ka tag",
    "stay": "Joog",
    "animalFarm": "Beerta Xoolaha",
    "animalFarmH": "Beerta Xoolaha",
    "animalOrigin": "Asalkii xoolaha",
    "animalOriginH": "Asalkii xoolaha",
    "farmOfOrigin": "Beerta Asal ahaan",
    "farmOfOriginH": "Beerta Asal ahaan",
    "selectFarm": "Dooro Beer",
    "searchFarm": "Beero Raadi",
    "confirmation": "Xaqiijinta",
    "proceed": "Sii wad",
    "ok": "OK",
    "animal": {
      "tagH": "Tag",
      "tagNumberH": "Lambarka Tag: Waxaad ku dari kartaa midab iyo sidoo kale nambar. ",
      "goveRegNoH": "Lambarka la bixiyay marka la iska diiwaan gelinayo urur dowladeed",
      "birthWeightH": "Miisaanka Dhalashada ee Kubka",
      "birthEaseH": "Dhalmada xooluhu waa hab dabiici ah, laakiin mararka qaarkood waxaa dhici karta dhibaatooyin xagga dhalmada ah oo biyo-xireenku uga baahan yahay in laga caawiyo beeralayda/xoolo-dhaqatada.",
      "birthFarmH": "Beerta asal ahaan/dhalashada xoolaha.",
      "surrogateDamH": "Aqoonsiga lo'da dheddigga ah ee ukunta la bacrimiyay ee ka timid deeq-bixiye lab iyo dheddig deeq-bixiye ayaa lagu beeray si ay u sii koraan.",
      "ownerH": "Kani waa magaca mulkiilaha neefka.",
      "damH": "Aqoonsiga waalidka/hooyada xayawaanka ee dumarka ah.",
      "sireH": "Aqoonsiga Labka Waalidka/Aabaha Xoolaha.",
      "breedH": "Taranku waa koox gaar ah oo xayawaan guri ah oo leh muuqaal isku mid ah (phenotype), dabeecad isku mid ah, iyo/ama astaamo kale oo ka sooca noolaha kale ee isku nooc ah.",
      "conceptionMethodH": "Sida neefka loo uuray.",
      "genderH": "Jinsiga xoolaha.",
      "dobH": "Taariikhda dhalashada xayawaanka.",
      "operatorH": "Magaca qofka buuxinaya macluumaadka xayawaankan.",
      "removalFarmH": "Beerta Xoolaha laga saaray ",
      "dateOfRemovalH": "Taariikhda xoolaha laga saaray",
      "destinationOfRemoval": "Meesha neefka laga saaray",
      "reasonOfRemovalH": "Sababta xoolaha laga saaray",
      "trackingNumberH": "Tirada loo qoondeeyay neefka marka neefka laga saaro",
      "brandH": "Calaamad - Kaliya calaamad joogto ah oo lagu gubay sac.",
      "tattoH": "Tattoo ku saabsan xayawaanka.",
      "hornStatusH": "Haddi neefka laga xayuubiyo.",
      "animalOriginH": "Dalka ay ka yimaadeen xoolaha.",
      "previousOwnerH": "Magaca mulkiilihii hore ee neefka haddii uu yahay mid qaan-gaar ah.",
      "twinH": "Goobtan ayaa sheegaysa in xayawaanku uu leeyahay mataano iyo in kale.",
      "regBreedAssoNoH": "Diiwaangelinta Ururada/Bulshooyinka taranka.",
      "breedAssoNameH": "Magaca Ururada/Bulshooyinka neefka laga diiwaan geliyay",
      "breederH": "Kani waa magaca ururka keenay neefka.",
      "breeder": "Dhaliye",
      "noteH": "Qoraal(yaasha) muhiimka ah ee ku saabsan xayawaanka.",
      "accuracyWeight_for_field": "Miisaanka Saxda ah",
      "conception": "Fikradda",
      "addAnAnimal": "Kudar Xayawaan",
      "addAnimal": "Ku dar Xoolaha",
      "registerAnAnimal": "Diiwaangeli Xoolaha",
      "uploadAnAnimal": "Soo rar xayawaan",
      "animalRegistration": "Diiwaangelinta Xoolaha",
      "animalDetails": "Faahfaahinta Xoolaha",
      "tag": "Tag",
      "tagNumber": "Lambarka Tag",
      "govtRegNumber": "Dowlada ",
      "birthWeight": "Miisaanka Dhalashada (lbs)",
      "birthEase": "Fududeynta Dhalashada",
      "birthFarm": "Beerta Dhalashada",
      "surrogateDam": "Biyo-xidheenka Surrogate",
      "owner": "Milkiilaha",
      "ownershipType": "Nooca Lahaanshaha",
      "animalDiseaseRecord": "Diiwaanka Cudurrada Xoolaha",
      "govtReg": "Dowlada ",
      "regDate": "Taariikhda Reg",
      "dam": "Biyo-xidheenka",
      "sire": "Sirdoon",
      "heifer": "qaalin",
      "steer": "Jiheeyaha",
      "calf": "Dibi",
      "farmHerd": "Beer / adhi",
      "femaleCalf": "Webiga dheddigga ah",
      "maleCalf": "Webiga lab",
      "newCalves": "Waylo Cusub",
      "breed": "Taranka",
      "conceptionMethod": "Habka fikradda",
      "gender": "Jinsiga",
      "dateOfBirth": "Taariikhda Dhalashada",
      "operator": "Hawl-wadeen",
      "animalRemovedFarm": "Beerta Xoolaha laga saaray",
      "dateOfAnimalRemoval": "Taariikhda Bixinta Xoolaha",
      "destinationOfRemovedAnimal": "Meesha Xayawaanka La Saaray",
      "reasonOfRemoval": "Sababta Ka Saaridda",
      "optionalAnimalInformation": "Macluumaadka Xoolaha Ikhtiyaarka ah",
      "animalPicture": "Sawirka Xoolaha",
      "trackingNumber": "Lambarka raad Raaca",
      "brand": "Summada",
      "tatto": "Tattoo",
      "hornStatus": "Xaaladda Geeska",
      "animalOrigin": "Asalkii xoolaha",
      "previosOwner": "Mulkiilaha Hore",
      "twin": "mataan",
      "InABreedAssociation": "Reg.",
      "nameOfBreedAssociations": "Magaca Ururada taranka",
      "breedAssociations": "Ururada taranka",
      "breederSupplier": "Beere (Alaab-qeybiye)",
      "importAnimal": "Soo dejinta Xoolaha",
      "loadingAnimals": "Soodejinaya Xayawaanka... Fadlan sug",
      "totalRegAnimals": "Wadarta Reg. ",
      "totalPregnantAnimals": "Wadarta Xayawaanka Uurka leh",
      "pregnantAnimalHistory": "Taariikhda Xoolaha Uurka leh",
      "dailyAnimalPregnancyUpdates": "Cusboonaysiinta Uurka Xoolaha Maalinlaha ah",
      "animalHistory": "Taariikhda Xoolaha",
      "dailyAnimalUpdates": "Cusbooneysiinta Xoolaha Maalinlaha ah",
      "totalPregnant": "Wadarta Uurka",
      "totalNewBorn": "Wadarta Dhalashada Cusub",
      "searchByIDGOVRegTag": "Ku raadi Aqoonsi, GOV Reg iyo Tag",
      "noANIMALAVAILABLE": "XAYAWAAN LA HELI KARO",
      "associationNumber": "Lambarka Ururka",
      "associationName": "Magaca Ururka",
      "destinationName": "Magaca Meesha",
      "plastic": "caag",
      "metal": "Birta",
      "naturalMating": "Dabeecadda Dabiiciga ah",
      "artificialInsemination": "Barashada macmalka ah",
      "embryoTransfer": "Wareejinta embriyaha",
      "noAssistance": "Gargaar la'aan",
      "someAssistance": "Qaar ka mid ah Caawinta",
      "mechanicalAssistance": "Kaalmada Makaanikada",
      "aCesareanSection": "Qalliinka qalliinka",
      "abnormalDelivery": "Bixinta aan caadiga ahayn",
      "male": "Lab",
      "female": "Dheddig",
      "castrated": "La tuuray",
      "sale": "Iibka",
      "slaughter": "gowrac",
      "death": "Geerida",
      "theft": "Tuugnimo",
      "other": "Mid kale",
      "horned": "Geeska",
      "polled": "Codeeyay",
      "dehorned": "Xurguf",
      "details": "Faahfaahin",
      "performance": "Waxqabadka",
      "geneticWorth": "Qiimaha Hidde",
      "healthRecord": "Diiwaanka Caafimaadka",
      "genotypeData": "Xogta Genotype",
      "reminders": "Xusuusin",
      "activityLog": "Diiwaanka Hawlaha",
      "activityLogDetails": "Faahfaahinta Diiwaanka Hawsha",
      "editAnimal": "Wax ka beddel Xoolaha",
      "familyInfo": "Macluumaadka Qoyska",
      "breedInfo": "Macluumaadka taranka",
      "identification": "Aqoonsiga",
      "removalInfo": "Macluumaadka ka saarida",
      "iDOfAnimalDam": "Aqoonsiga biyo-xidheenka xayawaanka.",
      "iDOfAnimalSire": "Aqoonsiga seeriga xayawaanka.",
      "iDOfDamEmbryoUsed": "Aqoonsiga biyo-xidheenka embriyaha la isticmaalay.",
      "animalHasATwinOrNot": "Haddii neefku mataano leeyahay iyo in kale.",
      "breedType": "Nooca taranka",
      "breedOfTheAnimal": "Tani waa nooc ka mid ah xayawaanka.",
      "regBreedAssociations": "Diiwaangelinta Ururada/Bulshooyinka taranka.",
      "nameOfAssociationsSocieties": "Magaca Ururada/Bulshooyinka neefka laga diiwaan geliyay.",
      "nameOfTheOrgSuppliedAnimal": "Kani waa magaca ururka keenay neefka.",
      "countryOriginAnimal": "Dalka ay ka yimaadeen xoolaha.",
      "birthFarmID": "Aqoonsiga Beerta Dhalashada",
      "farmIDAnimalBorn": "Aqoonsiga beerta ee uu neefku ku dhashay.",
      "currentOwner": "Mulkiilaha hadda",
      "nameOfOwnerAnimal": "Kani waa magaca mulkiilaha neefka.",
      "registrationDate": "Taariikhda Diiwaangelinta",
      "previousOwner": "Mulkiilihii hore",
      "nameOfOperator": "Magaca hawlwadeenka",
      "dateAnimalRemoved": "Taariikhda marka xoolaha laga saaro.",
      "destinationPlaceRemovedAnimal": "Meesha loo socdo neefka laga saaray",
      "namePersonFillAnimalInformation": "Magaca qofka buuxinaya macluumaadka xayawaankan.",
      "reasonOfAnimalRemoval": "Sababta xoolaha looga saaray",
      "reasonWhyTheAnimalIsRemoved": "Sababta neefka looga saaray",
      "processingDate": "Taariikhda habaynta",
      "DateInformationFilledChanged": "Taariikhda marka macluumaadka hadda la buuxiyay ama la beddelay.",
      "animalID": "Aqoonsiga xoolaha",
      "UniqueIdAnimal": "Kani waa id u gaar ah xayawaanka.",
      "plasticTagNumber": "Lambarka Taagga Caagga ah",
      "numberAnimalTag": "Tirada summada Xoolaha.",
      "rFTagNumber": "Lambarka Tag RF",
      "numberAnimalRFTag": "Tirada sumadda RF xayawaanka.",
      "govtRegNumb": "Dowlada ",
      "govtRegistrationNumber": "Faahfaahinta aqoonsiga oo ay ku jiraan magaca iyo ciwaanka shakhsiga, wakiilka shakhsiga ee adeega habsocodka, goobta hawsha la qabanayo, iyo sharaxaada adeega uu qofku bixiyo.",
      "numberAssignedAnimalIsRemoved": "Lambarka raadraaca waa mid ka mid ah aqoonsiga xoolaha loo isticmaalo la socodka dhaqdhaqaaqa xoolaha.",
      "dateOfAnimalRegistration": "Taariikhda diiwaangelinta xoolaha",
      "stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal": "Calaamad - Kaliya calaamad joogto ah oo lagu gubay sac.",
      "tattoOnAnimal": "Tattoo ku saabsan xayawaanka.",
      "whetherTheAnimalIsDehorned": "Haddi neefka laga xayuubiyo.",
      "milkingAnimals": "Xoolaha caanaha",
      "studAnimals": "Xayawaanka Uur",
      "animalInseminationRecord": "Diiwaanka taranka xoolaha",
      "numOfStrawsOrdered": "Tirada Caws la Dalbaday",
      "totalNumOfStraws": "Wadarta tirada cawska",
      "strawId": "Caws Id",
      "addSireAutomation": "Kudar Sire Automation",
      "addApprovalAutomation": "Kudar Oggolaanshaha Automation",
      "addCollectionAutomation": "Ku dar Automation Ururinta",
      "addStrawsAutomation": "Kudar Straws Automation",
      "addPackAutomation": "Ku dar Baakadka Automation-ka",
      "addPostageAutomation": "Kudar Automation Boostada",
      "searchBySire": "raadintaBySire",
      "numberOfProgenies": "Tirada Faraca",
      "sireEdit": "Sire Edit",
      "searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId": "Ku raadi Aqoonsiga Cawska, Tirada Guud ee Caws, Nambarka Dufcada iyo Aqoonsiga Goobta",
      "searchByPackIdNumberOfStrawsOrderedPackingTechnicia": "Ku baadh Xidhmada Id, Tirada cawska la dalbaday, Farsamada Xidhmada",
      "searchByCollectionAndPreparationTechnicia": "Ku raadi farsamada ururinta iyo diyaarinta",
      "registerSemenAutomation": "Diiwaangeli Automation-ka shahwada",
      "addSemenAutomation": "Ku dar Automation shahwada",
      "strawAutomationRegistered": "Cawska Automation-ka wuu diiwaan gashan yahay",
      "strawAutomationRegisteredNotRegistered": "Caws Automation lama diwaan gashanayn",
      "sireAutomationRegistered": "Sire Automation-ka waa la diiwangeliyay",
      "sireAutomationNotRegistered": "Sire Automation ma diiwaan gashanayn",
      "postageAutomationIsRegistered": "Automation-ka Boostada waa la diiwangeliyay",
      "postageAutomationNotRegistered": "Automation Boostada Lama Diiwangelin",
      "packAutomationIsRegistered": "Baakadaha Automation-ka waa diwaan gashan yahay",
      "packAutomationNotRegistered": "Baakadaha Automation-ka lama diiwaan-gelin",
      "postageAutomationIsUpdated": "Automation Boostada waa la cusboonaysiiyay",
      "postageAutomationNotUpdated": "Automation Boostada lama cusboonaysiin",
      "packAutomationIsUpadted": "Baakadaha Automation-ka waa la cusboonaysiiyay",
      "packAutomationNotUpadted": "Baakadaha Automation-ka lama cusbooneysiin",
      "collectionAutomationUpdated": "Automation Uruurinta waa la cusboonaysiiyay",
      "collectionAutomationNotUpdated": "Automation-ka ururinta lama cusboonaysiin",
      "approvalAutomationIsUpdated": "Automation Oggolaanshaha waa la cusboonaysiiyay",
      "approvalAutomationIsNotUpdated": "Automation Oggolaanshaha lama cusboonaysiin",
      "collectionAutomationRegistered": "Automation Automation-ka Ururinta wuu Diwaan gashan yahay",
      "collectionAutomationNotRegistered": "Automation-ka Ururinta lama diwaan-gelin",
      "approvalAutomationIsRegistered": "Automation-ka Oggolaanshaha waa la diiwangeliyay",
      "approvalAutomationIsNotRegistered": "Oggolaanshaha Automation-ka lama diiwaan-gelin",
      "strawAutomationUpdated": "Caws Automation la cusbooneysiiyay",
      "strawAutomationIsNotUpdated": "Automation-ka cawska lama cusboonaysiin",
      "searchSire": "Raadi Sire",
      "strawsEdit": "Caws Edit",
      "nextAnimals": "Xayawaanka xiga",
      "performanceInfo": {
        "milk": "Caano",
        "liveweight": "Miisaanka nool",
        "score": "Dhibcaha",
        "fertility": "Bacriminta",
        "measurements": "Cabbiraadaha",
        "dailyProteinYield": "Wax-soosaarka borotiinka maalinlaha ah",
        "amountProteinMilkCowDay": "Qadarka borotiinka caanaha laga helo lo'da maalinta gaarka ah.",
        "dailyMilkYield": "Dhalidda caanaha maalinlaha ah",
        "volumeMilkCowDay": "Mugga caanaha laga helo sac gaar ah maalin gaar ah.",
        "dailyFatYield": "Wax-soosaarka Dufanka maalinlaha ah",
        "amountFatMilkCowDay": "Qadarka dufanka caanaha laga helay lo'da maalinta gaarka ah.",
        "dailyProteinContent": "Maadada borotiinka maalinlaha ah",
        "dailyFatContent": "Dufanka maalinlaha ah",
        "milkLactose": "Caanaha Lactose",
        "amountLactoseMilk": "Qadarka lactose ee caanaha.",
        "milkUrea": "Urea caanaha",
        "indicatorAmountCrudeProtein": "Tusiyaha tirada borotiinka cayriin ee ku jira cuntada lo'da",
        "lactationNumber": "Lambarka nuujinta",
        "ordinalNumLactation": "Tirada caadiga ah ee nuujinta.",
        "lengthOfLactation": "Dhererka nuujinta (tusaale, 23 maalmood)",
        "lactationLength": "Dhererka nuujinta",
        "milkingFrequency": "Inta jeer ee caanaha",
        "frequcnyOfMilking": "Inta jeer ee caanaha (sida 2 jeer/maalintii)",
        "liveWeightInformation": "Xogta Miisaanka Nool",
        "currentWeight": "Culayska Hadda",
        "weightAnimal": "Miisaanka xayawaanka.",
        "postWeaningGain": "Faa'iidada naaska ka dib",
        "dailyGainInAnimalWeightWeaning": "Korodhka maalinlaha ah ee miisaanka xayawaanka ka dib naaska naaska.",
        "weaningWeight": "Miisaanka naaska",
        "weightAnimalMeasuredWeaning": "Miisaanka xoolaha oo lagu qiyaaso maalinta naaska naaska.",
        "averageDailyGain": "Celceliska Faa'iidada Maalinlaha ah",
        "averageAmountWeightAnimalGainFeedingPeriod": "Celceliska qiyaasta miisaanka xayawaanku wuxuu kordhin doonaa maalin kasta inta lagu jiro xilliga quudinta",
        "carcassWeight": "Miisaanka bakhtiga",
        "weightAnimalsHideInternalOrgansRemoved": "Miisaanka xayawaanka ka dib madaxa, maqaarka iyo xubnaha gudaha ayaa laga saaray.",
        "weightAtCalving": "Miisaanka dhalmada",
        "weightAtTheTimeOfCalving": "Miisaanka wakhtiga dhalmada.",
        "yearlingWeight": "Miisaanka Sannadka",
        "weightYearOldAnimal": "Miisaanka neefka jira hal sano.",
        "somaticCellScore": "Dhibcaha unugyada somatic",
        "somaticCellScoreIndicatorMastitis": "Dhibcaha unugyada somatic sida tilmaame naaso ",
        "lastUpdate": "Cusbooneysii Ugu Dambeeyay",
        "bodyConditionScore": "Dhibcaha xaalada jidhka",
        "scoreAnimalFat": "Dhibcaha xayawaanka marka loo eego inta baruur ee uu leeyahay.  ",
        "teatScore": "Dhibcaha naaska",
        "scoreMeasureingShapeTeats": "Dhibcaha cabbirka naasuhu waa qiimayno shakhsiyeed ee dhererka naaska iyo wareegga waxayna u dhexeeyaan 9 (aad u yar) ilaa 1 (aad u weyn). ",
        "udderScore": "Dhibcaha Joojinta candhada",
        "scoreMeasureingShapeOfUdder": "Qaabka cabbirka candhada (1-9 dhibcood). ",
        "whetherAnimalEasyBirthDifficult": "Dhalmada xooluhu waa hab dabiici ah, laakiin mararka qaarkood waxaa dhici karta dhibaatooyin xagga dhalmada ah oo biyo-xireenku uga baahan yahay in laga caawiyo beeralayda/xoolo-dhaqatada.",
        "totalLongevity": "Wadarta Cimriga",
        "survivalLactationTraitCowCulledBreeding": "Badbaadada laga bilaabo 1aad ilaa 5aad nuujinta. ",
        "docility": "Docility",
        "circumferenceBullScrotal": "Wareega xiniinyaha dibiga",
        "intervalSuccessInsemination": "Inta u dhaxaysa laga bilaabo kowaad ilaa dhalidda guulaysata.",
        "ageAtFirstCalving": "Da'da Dhalmada Koowaad",
        "ageCowCalving": "Waa imisa da'da lo'da dhalmada ugu horreysa.",
        "calvingInterval": "Inta u dhaxaysa dhalmada",
        "periodCalving": "Muddada ka dhalata dhalmada ilaa dhalmada xigta.",
        "scrotalCircumference": "Wareegga xiniinyaha",
        "estrusDetection": "Ogaanshaha Estrus",
        "trackingBehaviorAnimalDetectingEstrus": "La socodka dhaqanka dhaqdhaqaaqa xayawaanka si loo ogaado estrus ee lo'da.",
        "presenceOfEstrus": "Joogitaanka Estrus",
        "isCowInEstrusStage": "Waa marka sac ku jiro marxaladda estrus ama ama",
        "matureWeight": "Miisaanka qaan-gaarka ah",
        "weightAnimalDefinedAge": "Miisaanka xayawaanka da'da qeexan.",
        "matureHeight": "Dhererka qaangaarka ah",
        "heightAnimalDefinedAge": "Dhererka xayawaanka da'da qeexan.",
        "footClawSet": "Dejinta Cidiyaha Cagaha",
        "shapeAnimalClaw": "Qaabka cidi xoolaha.",
        "pulmonaryArterialPressure": "Cadaadiska halbowlaha sambabada",
        "animalBloodPreasure": "Dhiig karka xoolaha.",
        "footAngle": "Xagasha cagta",
        "shapeAnimalFoot": "Qaabka cagta xoolaha.",
        "ribEyeArea": "Aagga feedhaha",
        "amountRibEyeArea": "Qadarka aagga feeraha isha.",
        "ultrasoundFat": "Dufanka Ultrasound",
        "measureFatAmount": "Cabbirka xadiga baruurta.",
        "ultrasoundIntramuscularFat": "Dufanka Muruqa ee Ultrasound",
        "ultrasoundRibEyeArea": "Aagga feeraha-Isha ee Ultrasound",
        "measureRibeyeArea": "Cabbirka aagga ribeeye.",
        "fatThickness": "Dufanka Baruurta",
        "amountAnimalBackFat": "Qadarka dufanka dhabarka xoolaha.",
        "marbling": "Marbling",
        "marballingMeasurement": "Marbling waa dufan muruqa ah oo muuqda oo aan dheregsanayn (caafimaad leh) kaas oo ku urura gudaha muruqa iyo inta u dhaxaysa xidhmooyinka fiber muruqa.",
        "dryMatterIntake": "Qaadashada arrin qalalan",
        "amountFeedAnimalConsumesAMoisture": "Qadarka quudinta uu xayawaanku isticmaalo maalintii si aan qoyaan lahayn."
      },
      "feedsName": "Magaca Quudinta",
      "feedName": "Magaca Quudinta",
      "firstFeedQuantity": "Quantity Quantity First",
      "additionalFeed": "Quudinta Dheeraadka ah",
      "cloversRyeGrasses": "Clovers, cawska galley",
      "greenFodderHayLegumes": "Calafka cagaaran, Xayawaanka, digirta",
      "feedsRegisteredSuccessfully": "Quudinta ayaa si guul leh loo diiwaan geliyay",
      "feedsNotRegistered": "Quudinta Aan Diiwaan Gelin",
      "fEEDQUANTITY": "QUUDINTA TIRADA",
      "feedQuantity": "Quantity Quantity",
      "fEEDNAME": "MAGACA FEEDKA",
      "nOFEEDINFOAVAILABLE": "MACLUUMAADKA QUUDINTA OO LA HELI KARO",
      "searchByFeedName": "Ku raadi magaca Quudinta",
      "loadingFeedInfo": "Soodejinaya Macluumaadka Quudinta... Fadlan sug",
      "todayFeedInfo": "Macluumaadka Quudinta Maanta",
      "feedInfo": "Macluumaadka Quudinta",
      "loremIpsumDolorSitAmet": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      "geneticWorthInfo": {
        "breedingValueEconomicIndex": "Haddii qiimaha taranka loo isticmaalo xisaabinta tusmada dhaqaalaha.",
        "dailyProteinYieldUsed": "Soosaarka borotiinka maalinlaha ah ee la isticmaalo",
        "weightAssignedBreedingDailyProteinYield": "Miisaanka loo qoondeeyay qiimaha taranka ee u dhiganta \"wax soo saarka borotiinka maalinlaha ah\". ",
        "dailyProteinYieldWeight": "Miisaanka Waxsoosaarka Barootiinka Maalinlaha ah",
        "rankAnimalInRelationshipEconomicIndex": "Darajada xayawaanka ee xiriirka la leh tusmada dhaqaalaha.",
        "economicIndexRank": "Darajada Dhaqaalaha",
        "percentileEconomicIndexFall": "Boqolkiiba tusmada dhaqaale ee ku dhaca.",
        "economicIndexPercentile": "Tusmada Dhaqaalaha",
        "accuracyOfEconomicIndex": "Saxnaanta tusmada dhaqaalaha.",
        "economicIndexAccuracy": "Saxnaanta Tusmada Dhaqaalaha",
        "weightedAverageOfBreedingValues": "Celceliska qiyamka taranka ee la miisaamay.",
        "economicIndex": "Tusmada Dhaqaalaha",
        "rankOfAnimalInRelationshipBreeding": "Darajada xayawaanka ee xiriirka u dhiganta qiimaha taranka.",
        "dailyProteinYieldBreedingValueRank": "Qiimaha taranka borotiinka maalinlaha ah ",
        "percentileBreedingFalls": "Boqolkiiba qiimaha taranku ku dhaco.",
        "dailyProteinYieldBreedingPercentile": "Qiimaha taranka borotiinka maalinlaha ah ",
        "accuracyEstimatedBreeding": "Saxnimada qiyaasta taranka.",
        "dailyProteinYieldBreedingAccuracy": "Saxnaanta Qiimaha Dhalinta Barootiinka Maalinlaha ah",
        "estimatedBreedingTraitDailyProteinYield": "Qiyaasta qiimaha taranka ee sifada \"Dhibka borotiinka maalinlaha ah.",
        "dailyProteinYieldBreedingValue": "Qiimaha Dhalinta Wax-soosaarka Borotiinka Maalinlaha ah ",
        "pathToTheDirectoryScriptsBreeding": "Jidka loo maro tusaha dariiqa adag ee ay ka kooban yihiin qoraalo kuwaas oo loo isticmaalay xisaabinta qiimaha taranka.",
        "scriptsPath": "Jidka Scripts",
        "softwarePackageBreeding": "Xidhmada software taas oo loo isticmaalay in lagu xisaabiyo qiimaha taranka.",
        "breedingValueSoftware": "Software-ka Qiimaha Taranta",
        "methodCalculateBreeding": "Habka loo isticmaalay xisaabinta taranka",
        "breedingValueMethod": "Habka Qiimaha Taranka",
        "trait": "Sifada",
        "tools": "Qalab",
        "geneticWorth": "Qiimaha Hidde",
        "dailyProteinYield": "Wax-soosaarka borotiinka maalinlaha ah",
        "breedingValue": "Qiimaha taranka",
        "breedingValueBIFAccuracy": "Qiimaha Taranka ee Saxnaanta BIF",
        "breedingValuePercentile": "Boqolleyda Qiimaha Taranka",
        "breedingValueRank": "Darajada Qiimaha Taranka",
        "checkLTD": "Hubi LTD",
        "ultrasoundDiagnostic": "Baaritaanka Ultrasound",
        "selectYieldUsed": "Dooro Waxsoosaarka la isticmaalay",
        "softwareName": "Magaca software",
        "animalGenWorthUpdatedSuccessfully": "Animal Gen Worth waa la cusbooneysiiyay si guul leh"
      },
      "addNote": "Kudar Xusuusnow",
      "enterNote": "Geli Xusuusin",
      "noteIsRequired": "Ogeysiis ayaa loo baahan yahay",
      "noteMustBeLessThan50Characters": "Xusuusintu waa in ay ka yaraataa 50 xaraf",
      "noteAdded": "Xusuusin Lagu Daray",
      "noteNotAdded": "Xusuusin Laguma Darin",
      "noteForAnimal": "Xusuusin xayawaanka.",
      "noNoteFoundForThisAnimal": "Wax qoraal ah looma helin xayawaankan.",
      "inseminationData": "Xogta faafinta",
      "nameOfInseminator": "Magaca inseminator",
      "activity": "Dhaqdhaqaaqa",
      "searchByNameActivity": "Ku raadi magac ahaan, hawlqabad",
      "searchByTaskNameNumber": "Ku raadi magaca hawsha, lambarka",
      "inseminationDate": "Taariikhda Dhalinta",
      "genotypeDataInfo": {
        "genotypeAnimalID": "Aqoonsiga Xayawaanka ee Genotype",
        "iDTubeBloodSampleAnimalNumberGenotypingService": "Kani waa aqoonsiga tuubo leh muunad dhiig oo laga soo qaaday xayawaanka ama tiro adeega genotyping ah",
        "geneticTechnicianName": "Magaca Farsamada Hiddaha",
        "NameTechnicianBloodSamplesAnimal": "Kani waa magaca farsamayaqaan ka qaaday dhiig neefka",
        "sNPData": "Xogta SNP",
        "genotypingServiceNote": "Xusuusin Adeegga Genotyping",
        "InfoGenotypingGenotypingTechnology": "Dhammaan macluumaadka la xidhiidha genotyping sida magaca shirkadda genotyping, tignoolajiyada genotyping ee la isticmaalay, taariikhda genotyping, iwm",
        "numberOfSNPs": "Tirada SNPs",
        "numberOfSNPsAnimalGenotyped": "Tirada SNP-yada neefka ayaa loo qaybiyay",
        "nameOfTheDrug": "Magaca Dawada",
        "animalGenoDataUpdatedSuccessfully": "Xogta Geno ee Xoolaha ayaa si guul leh loo cusboonaysiiyay",
        "animalGenoDataNotUpdated": "Xogta Geno ee Xayawaanka lama cusbooneysiin",
        "animalIDIsRequired": "Aqoonsiga xoolaha ayaa loo baahan yahay",
        "techNameIsRequired": "Farsamada ",
        "onlyAlphabetsAreAllowed": "Alifbeetada kaliya ayaa la oggol yahay",
        "genoDataIsRequired": "Xogta Geno ayaa loo baahan yahay",
        "serviceNoteIsRequired": "Ogeysiiska Adeegga ayaa loo baahan yahay",
        "sNPIsRequired": "SNP ayaa loo baahan yahay"
      },
      "healthRecordInfo": {
        "treatment": "Daawaynta",
        "treatmentTakenAnimal": "Maxaa lagu daweeyay xoolaha.",
        "reasonOfTreatment": "Sababta Daawaynta",
        "reasonForTreatment": "Sababta Daawaynta",
        "whatReasonOfTreatment": "Waa maxay sababta daawaynta.",
        "treatmentDate": "Taariikhda daawaynta",
        "dateOfTreatment": "Taariikhda daawaynta.",
        "diagnosis": "ogaanshaha",
        "nameDiagnosedDiseaseConditionSymptoms": "Magaca cudur/xaalad ama calaamadaha ugu muhiimsan ee la ogaaday",
        "drugID": "Aqoonsiga daawada",
        "iDOfDrugWhichIsGivenToAnimal": "Aqoonsiga daroogada ee la siiyo xayawaanka.",
        "drugName": "Magaca daroogada",
        "nameDrugAnimal": "Magaca daroogada oo loo bixiyo xayawaanka.",
        "drugWithdrawalPeriod": "Muddada ka bixida daroogada",
        "timeAdministrationDrugAnimalMeatMilkHumanConsumption": "Waqtiga loo baahan yahay ka dib maamulka daroogada ee xayawaanka si loo hubiyo badbaadada hilibka ama caanaha isticmaalka aadanaha",
        "attendingVeterinarian": "Imaanshaha dhakhtarka xoolaha",
        "qualifiedPersonCaseAnimal": "Qofka aqoonta u leh ee arkay kiiska/xoolaha",
        "packID": "Xidhmada aqoonsiga",
        "iDPackTreatment": "Aqoonsiga xirmo loo isticmaalay daawaynta",
        "veterinarianName": "Magaca dhakhtarka xoolaha",
        "animalNoHealthRecord": "Xayawaankan malaha wax diiwaan caafimaad ah. ",
        "addHealthRecord": "Kudar Diiwaanka Caafimaadka",
        "healthStatus": "Xaalada Caafimaad",
        "loadingDiseasesPleaseWait": "Cudurrada soo raraya... Fadlan sug",
        "animalDiseaseRecord": "Diiwaanka Cudurada Xoolaha",
        "animalHealthRecord": "Diiwaanka Caafimaadka Xoolaha",
        "animalTreatmentRecord": "Diiwaanka Daaweynta Xoolaha",
        "loadingHealthData": "Soodejinaya xogta caafimaadka...",
        "healthRecord": "Diiwaanka Caafimaadka",
        "nameOfDiagnosis": "Magaca Cudurka",
        "treatmentName": "Magaca Daawaynta",
        "drugGivenBy": "Daawooyinka Uu Bixiyay",
        "recessiveDiseases": "Cudurada soo noqnoqda",
        "recessiveDiseasesMessage": "Waa kee cudurka dib-u-dhac ku yimaadda dibigani sidaha"
      },
      "conceptionInfo": {
        "addNewConception": "Ku dar fikrad cusub",
        "semenEmbryo": "shahwada/Urjiif",
        "pregnancyCheck": "Hubinta Uurka",
        "birthInfo": "Macluumaadka dhalashada",
        "searchByInseminatorOrganisationBreedingConception": "Ku raadi magaca Inseminator, Magaca ururka, lambarka adeegga taranka, Habka fikradda",
        "deliveryDate": "Taariikhda keenista",
        "calfId": "Kubi Id",
        "birthDayOldWeight": "Dhalashada (Maalin Hore) Miisaanka",
        "searchByBirthEase": "Ku baadh fududaanta Dhalashada",
        "searchPregnancyCheckOperatorMethod": "Ka raadi hawlwadeenka hubinta uurka, Habka hubinta uurka",
        "pregnancyCheckDate": "Taariikhda Hubinta Uurka",
        "conceptionSuccess": "Guusha ra'yiga",
        "pregnancyCheckOperator": "Hawlwadeenka Hubinta Uurka",
        "pregnancyCheckMethod": "Habka Hubinta Uurka",
        "recentlyPregnant": "Dhawaan Uurka Leh",
        "pregnancyConfirmationDate": "Taariikhda Xaqiijinta Uurka",
        "pregnancyRate": "Heerka Uurka",
        "timePeriodOfPregnancy": "Waqtiga Uurka",
        "semenProduction": "Soo saarista shahwada",
        "embryoProduction": "Wax-soo-saarka embriyaha",
        "semen": "shahwada",
        "embryoTransferDate": "Taariikhda wareejinta embriyaha",
        "daysOfPregnancy": "Maalmaha Uurka",
        "searchSireEmbryoSurrogate": "Ku raadi sire id, Embryo org name, Surrogate Dam",
        "selectDate": "Dooro Taariikhda",
        "orgnisationNameContainNumber": "Magaca ururka waa in aanu ku jirin lambar",
        "selectBirthEase": "Dooro Fududeynta Dhalashada",
        "selectUnit": "Fadlan door halbeeg",
        "animalConceptionAddedSuccessfully": "rimidda Xayawaanka oo lagu guulaystey",
        "postageCustomerName": "Magaca Macmiilka Boostada",
        "searchByPostageCustNameCustAddPostId": "Ku raadi Magaca Macmiilka Boostada, Ciwaanka Macmiilka, Aqoonsiga Boostada",
        "dateOfSemenCollection": "Taariikhda Ururinta shahwada",
        "dateOfSemenPreparation": "Taariikhda Diyaarinta shahwada",
        "semenMotility": "Dhaqdhaqaaqa shahwada",
        "semenConcentration": "Isku-duubnaanta shahwada",
        "postageEdit": "Tafatirka Boostada",
        "enterSireId": "Geli aqoonsiga sire",
        "selectEmbryoOrganisation": "Dooro Ururka Embriyo",
        "matingDateH": "Taariikhda rimidda, ha ahaato lammaane dabiici ah ama barar macmal ah.",
        "inseminatorNameH": "Qofka sameeya habka taranka (dhakhtarka xoolaha/farsamada)",
        "orgNameH": "Magaca ururka ama shirkadda siisa cawska shahwada ee AI",
        "brServiceNumH": "Duubista tirada taranka (tusaale 1aad, 2aad, ama 3aad)",
        "conceptionMethodH": "Habka uu neefku uur u yeeshay oo ah bilowga uurka, oo lagu garto bacriminta ukunta shahwada.",
        "sireIdH": "Aqoonsiga Labka Waalidka/Aabaha Xoolaha",
        "damIdH": "Aqoonsiga waalidka/hooyada xayawaanka ee dumarka ah.",
        "sarogatedDamH": "Aqoonsiga lo'da dheddigga ah ee ukunta la bacrimiyay ee ka timid deeq-bixiye lab iyo dheddig deeq-bixiye ayaa lagu beeray si ay u sii koraan.",
        "embOrgNameH": "Magaca ururka ee embriyaha",
        "sarogateDamBreedH": "Taariikhda taranka beddelka",
        "sireBreedH": "Nooca taranka seeriga (braham, boran)",
        "pregCheckDateH": "Uurka waxaa lagu ogaan karaa lo'da ugu horrayn 30 maalmood iyadoo la isticmaalayo ultrasound iyo baaritaanka dhiigga. Lo'da si loo aqoonsado inuu uur leh iyadoo la isticmaalayo habka palpation, lo'da inta badan waxay u baahan yihiin ugu yaraan 35-50 maalmood uur. ",
        "conceptionSuccessH": " Lo'da, heerka bacriminta waa 90% celceliska dhalmada ee ku saabsan 55%, taas oo muujinaysa dhimashada uurjiifka iyo uurjiifka qiyaastii 35% (Diskin et al., 2006). ",
        "pregnancyCheckOperatorH": "Dhakhaatiirta xoolaha iyo farsamayaqaannada xoolaha ee takhasuska leh ayaa inta badan adeegyadan siiya beeralayda. ",
        "pregnancyCheckMethodH": "Labada hab ee ugu badan ee loo isticmaalo ogaanshaha uurka ee lo'du waa garaacista gacanta ee mareenka taranka (malawadka) iyo ultrasonography transrectal ee mareenka taranka",
        "deliveryDateH": "Taariikhda marka dhalmada ay dhacayso",
        "calfIdH": "Aqoonsiga webiga cusub ee dhashay",
        "birthEaseH": "Dhalmada xooluhu waa hab dabiici ah, laakiin mararka qaarkood waxaa dhici karta dhibaatooyin xagga dhalmada ah oo biyo-xireenku uga baahan yahay in laga caawiyo beeralayda/xoolo-dhaqatada.",
        "birthDayOldWeightH": "Miisaanka xayawaanka maalinta dhalashada ama miisaanka shimbir hal maalin jira",
        "customerAddress": "Cinwaanka Macmiilka"
      },
      "all": "Dhammaan",
      "ungrouped": "Xayawaanka aan la ururin",
      "active": "Xayawaanka kooxaysan",
      "updateAnimal": "Cusbooneysii Xoolaha"
    },
    "dashboardS": {
      "dailyActivities": "Hawlaha maalinlaha ah",
      "pendingTasks": "Hawlaha la sugayo",
      "performanceOfGeno": "Waxqabadka Genotypes",
      "breed": "Taranka",
      "chromosome": "Chromosome",
      "seqChange": "Isbeddelka Taxanaha",
      "inheritance": "Dhaxalka",
      "diseaseName": "Magaca Cudurka",
      "refSequence": "Tixraaca Tixraaca",
      "pubmedRef": "Tixraaca la daabacay",
      "matingDate": "Taariikhda Galmada",
      "inseminatorName": "Magaca Inseminator",
      "orgName": "Magaca Ururka",
      "brServiceNum": "Lambarka Adeegga Taranka",
      "conceptionMethod": "Habka fikradda",
      "semEmbInfo": "Macluumaadka shahwada/Ereysiga",
      "sireId": "Aqoonsiga Sirta",
      "damID": "Aqoonsiga Dambiga",
      "srgDamId": "Aqoonsiga Biyo-xidheenka Surrogate",
      "embOrgName": "Embryo Org. ",
      "srgDamBreed": "Ku-meel-gaadhka Dhaamka Dhaamka",
      "sireBreed": "Sire Breed",
      "damBreed": "Tarankii Dambe"
    },
    "user": {
      "selectLanguage": "Dooro Luuqad",
      "unitPreference": "Xulashada unugga",
      "selectUnitOfMeasure": "Xulo halbeegga cabbirka",
      "importedUser": "Isticmaale la soo dejiyay",
      "impFileStatus": "Soo rar Xaaladda faylka",
      "loadingUser": "Soodejinaya Isticmaalayaasha... Fadlan sug",
      "totalUsers": "Wadarta Isticmaalayaasha",
      "pendingUsers": "Isticmaalayaasha la sugayo",
      "changePassword": "Badalida Lambarka sirta ah",
      "goodIdeaToUsePassword": "Waa fikrad wanaagsan inaad isticmaasho furaha sirta ah ee adag oo aadan meel kale isticmaalin.",
      "enterCurrentPassword": "Geli erayga sirta ah ee hadda",
      "enterNewPassword": "Geli Password Cusub",
      "reEnterPassword": "Dib u geli erayga sirta ah ee cusub",
      "enterPassword": "Geli erayga sirta ah",
      "repeatNewPassword": "Ku celi sirta cusub",
      "emailAddr": "Cinwaanka emailka",
      "enterYourPhoneNumber": "Geli lambarka taleefankaaga",
      "pleaseTypeOldPassword": "Fadlan ku qor erayga sirta ah ee hore",
      "pleaseTypeNewPassword": "Fadlan ku qor erayga sirta ah ee cusub",
      "pleaseTypeConfirmPassword": "Fadlan ku qor lambarka sirta ah ee xaqiijin",
      "passwordChangedSuccesFully": "Si guul leh ayaa erayga sirta ah loo beddelay",
      "currentPassword": "Magaca Sirta Hadda",
      "newPassword": "Furaha cusub",
      "passwordDoesNotMatch": "Erayada sirta ah isma dhigmaan",
      "emailCanNotBeEmpty": "Iimaylku ma madhnaan karo",
      "profileUpdated": "Xogta la cusboonaysiiyay",
      "profileNotUpdated": "Profile Lama Cusbooneysiin",
      "unableToVerifyEmail": "Lama xaqiijin karo iimaylka",
      "otpSentOnEmail": "OTP ayaa lagu soo diray iimaylka",
      "otpSentSuccessFully": "OTP ayaa loo diray si guul leh",
      "importUsers": "Soo dejinta Isticmaalayaasha",
      "imageUpdated": "Sawirka oo la cusboonaysiiyay",
      "departmentName": "Magaca Waaxda",
      "departmentNum": "Lambarka Waaxda",
      "departmentAdded": "Waaxdii lagu daray",
      "departmentNotAdded": "Waaxda Laguma Darin",
      "searchDepartnment": "Ku raadi Magaca Waaxda ama Lambarka",
      "addDepartMent": "Kudar Waaxda",
      "addDepartment": "Kudar Waaxda",
      "roleNameIsRequired": "Magaca doorka ayaa loo baahan yahay",
      "roleNameMustBeLessThan15Chars": "Magaca doorku waa inuu ka yar yahay 15 xaraf",
      "roleAdded": "Doorka lagu daray",
      "editDepartment": "Tafatirka Waaxda",
      "departmentUpdated": "Waaxda La cusboonaysiiyay",
      "departmentNotUpdated": "Waaxda lama cusbooneysiin",
      "deleteDepartment": "Tirtir Waaxda",
      "deleteDepartmentMessage": "Ma hubtaa inaad doonayso inaad tirtirto waaxdan.",
      "noRoleAvailable": "DOOR LA HELI KARO",
      "roleUpdated": "Doorka waa la cusbooneysiiyay",
      "roleNotUpdated": "Doorka lama cusbooneysiin",
      "editRole": "Doorka wax ka beddel",
      "allRole": "Dhammaan Doorka",
      "addNewRole": "Kudar Door Cusub",
      "allDepartment": "Dhammaan Waaxda",
      "permissionsUpdated": "Ogolaanshaha la cusbooneysiiyay",
      "permissionsnotUpdated": "Ogolaanshaha lama cusboonaysiin",
      "roleNo": "Doorka No.",
      "searchByEmailAndName": "Ku raadi iimaylka iyo magaca",
      "userID": "Aqoonsiga isticmaale",
      "userUpdated": "Isticmaalaha waa la cusbooneysiiyay",
      "userNotUpdated": "Isticmaalaha lama cusbooneysiin",
      "userAdded": "Isticmaalaha lagu daray",
      "userNotAdded": "Isticmaalaha Laguma Darin",
      "activateUser": "Daar Isticmaalaha",
      "deactivateUser": "Jooji Isticmaalaha",
      "userStatusMsg": "Ma hubtaa inaad rabto inaad beddesho heerka isticmaale",
      "countryRequired": "Dalka ayaa loo baahan yahay",
      "stateRequired": "Gobolka ayaa loo baahan yahay",
      "cityRequired": "Magaalada ayaa loo baahan yahay",
      "searchByRole": "Ku Raadi Nambarka Doorka, Magaca doorka, Waaxda",
      "noModuleAvailable": "Ma jiro Module la heli karo",
      "searchBYModuleName": "Ku raadi Magaca Module"
    },
    "farm": {
      "farmID": "Aqoonsiga beerta",
      "onTheFarm": "Beerta",
      "userRoles": "Doorarka Isticmaalaha",
      "adduser": "Kudar Isticmaale",
      "addAuser": "Kudar Isticmaale",
      "uploadUsers": "Soo rar Isticmaalayaasha",
      "addNewUser": "Kudar Isticmaale Cusub",
      "selectDept": "Dooro Waaxda",
      "selectRole": "Dooro Doorka",
      "editUser": "Wax ka beddel Isticmaalaha",
      "totalFarms": "Wadarta Beeraha",
      "NoAnimalsRegisteredForthisFarm": "Ma jiro xayawaan u diwaan gashan beertan",
      "farmsPerPage": "Beeraha boggiiba",
      "regularFarms": "Beeraha Joogtada ah",
      "farmRegisteredProducts": "Alaabooyinka Diiwaangashan Beerta",
      "searchByFarmNameAndId": "Ku raadi Magaca Beeraha iyo Aqoonsiga",
      "loadingProductsPleaseWait": "Soodejinaya Alaabooyinka... Fadlan sug",
      "farmName": "Magaca Beerta",
      "farmLocation": "Goobta Beerta",
      "productName": "Magaca Alaabta",
      "stockStatus": "Heerka Saamiyada",
      "inStock": "In Stock",
      "searchByProductName": "Ku Raadi Magaca Alaabta",
      "productCategory": "Qaybta Alaabta",
      "products": "Alaabta",
      "farms": "Beeraha",
      "registerAfarm": "Diiwaangeli Beer",
      "govtRegistry": "Dowlada ",
      "cooperativeID": "Aqoonsiga iskaashiga",
      "farmType": "Nooca Beerta",
      "contractMating": "Qandaraaska Mating",
      "customization": "Habaynta",
      "recordsPerpage": "Diiwaanada bog kasta",
      "restoreDefault": "Soo Celinta Defaalka",
      "apply": "Codso",
      "searchState": "Ka raadi Aqoonsiga Beeraha, Diiwaanka Gov., Aqoonsiga Iskaashatada, Nooca Beerta, Qandaraaska Isku-xidhka",
      "farmOwner": "Milkiilaha Beerta",
      "govRegistrationNo": "Nambarka Diiwaangelinta Dowladda",
      "farmInformation": "Macluumaadka Beeraha",
      "ownershipType": "Nooca Lahaanshaha",
      "communityName": "Magaca Beesha",
      "farmLicenseInformation": "Macluumaadka Shatiga Beeraha",
      "licenseNumber": "Lambarka shatiga",
      "licenseExpiryDate": "Taariikhda uu dhacayo shatiga",
      "regulatorName": "Magaca maamulaha",
      "regulatorRepresentativeName": "Magaca Wakiilka Maamule",
      "farmLocationSize": "Goobta Beerta",
      "productionSystem": "Nidaamka Wax-soo-saarka",
      "country": "Dalka",
      "state": "Gobolka",
      "city": "Magaalada",
      "street": "Waddada",
      "houseNumber": "Lambarka Guriga",
      "farmRegistration": "Diiwaangelinta Beeraha",
      "cancel": "Jooji",
      "register": "Is diwaangeli",
      "ok": "ok",
      "totalFarmSize": "Wadarta Cabirka Beerta",
      "farmGeographicLocation": "Goobta Juqraafiga Beeraha",
      "perimeterPointLongitude": "Dhererka Barta Wareegga",
      "perimeterPointLatitude": "Wareegga Bar Latitude",
      "perimeterPointLabel": "Summada wareegga wareegga",
      "perimeterLength": "Dhererka wareegga",
      "farmLatitude": "Latitude Beerta",
      "farmLongitude": "Longitude Beerta",
      "editFarm": "Wax ka beddel Beer",
      "update": "Cusbooneysii",
      "editAfarm": "Tafatir beer",
      "nextFarm": "Beerta xigta",
      "nameoftheFarm": "Magaca Beerta",
      "registerAProduct": " Diiwaangeli A Alaabta",
      "farmProducts": "Alaabooyinka Beeraha",
      "calf": "Dibi",
      "steer": "Jiheeyaha",
      "heifer": "qaalin",
      "sire": "Sirdoon",
      "dam": "Biyo-xidheenka",
      "registerAnAnimal": "Diiwaangeli Xoolaha",
      "farmAnimals": "Xayawaanka Beerta",
      "farm_type": "Nooca beerta",
      "farm_Owner": "Milkiilaha Beerta",
      "dateOfRegistration": "Taariikhda Diiwangelinta",
      "dataIsNotAvailableForThisFarm": "Xogta Looma hayo Beertan",
      "registerNewProduct": "Diiwaangeli Alaabo Cusub",
      "information": "Xog",
      "licenseInfo": "Macluumaadka shatiga",
      "locationInfo": "Macluumaadka Goobta",
      "geoLocation": "Goobta Geo",
      "perimeterLengthState": "Dhererka Wareegtada Beeraha (dhererka xayndaabka)",
      "totalFarmSizeState": "Cabirka Beerta",
      "productionSystemState": "Nidaamka Wax-soo-saarka ee lagu isticmaalo Beerta",
      "contractMatingState": "Xeerka Barnaamijka Isku-xidhka Qandaraaska kaas oo beertu ka qayb-qaadato.",
      "ownershipTypeState": "Nooca Lahaanshaha",
      "regulatorRepresentativeNameState": "Magaca qofka matalaya maamulaha ee soo saaray shatiga",
      "regulatorNameState": "Magaca maamulaha ee soo saaray shatiga",
      "licenseExpiryDateState": "Taariikhda marka shatiga hadda dhacayo",
      "licenseNumberState": "Lambarka shatiga ee uu sii daayay Regulator",
      "plotNumberState": "Lambarka guriga ee beerta.",
      "plotNumber": "Guriga/Lambarka Goobta",
      "streetStatement": "Magaca waddada beerta.",
      "cityStatement": "Magaalada ay beertu ku taal.",
      "stateStatement": "Gobolka dalka ay beertu ku taal.",
      "countryState": "Dalka ay beertu ku taal.",
      "perimeterPointLongitudeState": "Longitude ee hal dhibic beerta.",
      "perimeterPointLatitudeState": "Latitude ee hal dhibic beerta.",
      "perimeterPointLabelState": "Summada Barta.",
      "farmLongitudeState": "Longitude ee beerta.",
      "farmLatitudeState": "Latitude ee beerta.",
      "farmNameH": "Magaca beerta",
      "farmTypeH": "Nooca beerta oo hawlo kala duwan laga fuliyo.",
      "farmOwnerH": "Magaca mulkiilaha beerta (magaca beeralayda oo gelaya macluumaadka si toos ah)",
      "ownershipTypeH": "Nooca beeralayda leh/maamula dhulka ay beertaan iyo kuwa aan lahayn.",
      "govtRegNumbH": "Lambarka diiwaanka beerta oo uu u xilsaaray maamule",
      "contractMatingH": "Xeerka barnaamijka isku dhafka qandaraasyada kaas oo beertu ka qayb qaadato",
      "productionSystemH": "Waa maxay nidaamka wax soo saarka ee loo isticmaalo beerta",
      "cooperativeIDH": "Aqoonsiga iskaashatooyinka ay beertu xubin ka tahay ",
      "licenseNumberH": "Aqoonsiga nambarka shatiga uu siidaayay maamulaha kaasoo tilmaamaya milkiilaha.",
      "licenseExpiryDateH": "Taariikhda marka shatiga hadda dhacayo",
      "regularNameH": "Magaca maamulaha ee soo saaray shatiga",
      "regularRepName": "Magaca qofka matalaya maamulaha ee soo saaray shatiga",
      "countryH": "Dalka ay beertu ku taal.",
      "stateH": "Gobolka dalka ay beertu ku taal.",
      "cityH": "Magaalada ay beertu ku taal.",
      "streetH": "Magaca waddada beerta.",
      "houseNumberH": "Lambarka guriga ee beerta.",
      "totalFarmSizeH": "Baaxadda beertu waa wadarta dhulka ay hadda beerato beertu oo ay ku jiraan dhulka hoostiisa ah laakiin aan ku jirin dhulka ku hoos jira dhirta dabiiciga ah, dhirta ama daaqa.",
      "farmLatitudeH": "Ma cabirka fogaanta waqooyi ama koonfurta dhulbaraha. ",
      "farmLongitudeH": "Waxay cabbirtaa fogaanta bari ama galbeed ee meeriska hore.",
      "perimeterLengthH": "Dhererka wareegyada beeraha (dhererka xayndaabka)",
      "perimeterPointLabelH": "Calaamadda dhibicda. ",
      "perimeterPointLatH": "Latitude ee hal dhibic beerta",
      "perimeterPointLongH": "Longitude ee hal dhibic beerta",
      "noProductAvailable": "Badeeco lama heli karo",
      "farmUpdated": "Beerta waa la cusboonaysiiyay",
      "performance": "Waxqabadka",
      "milkInformation": "Xogta caanaha",
      "farmNameRequired": "Magaca Beerta ayaa loo baahan yahay"
    },
    "login": {
      "welcome": "Soo dhawoow! ",
      "welInfo": "Geli warqadaha aqoonsiga",
      "login": "Soo gal",
      "forgotPassword": "Furaha la ilaaway",
      "forgotPasswordDesc": "Fadlan geli ciwaanka iimaylka ee la xidhiidha akoonkaaga ",
      "backToLogin": "Ku laabo Login"
    },
    "actionListmod": {
      "actionList": "Liiska Waxqabadka",
      "tODAY": "Maanta",
      "createTask": "Abuur Hawsha",
      "myActivities": "Hawlahayga",
      "jhonSmith": "Joon Smith",
      "farmID": "Aqoonsiga beerta",
      "dateOfEvent": "Taariikhda Dhacdada",
      "actionRequired": "Talaabo Loo Baahan Yahay",
      "actionTaken": "Talaabo Laga Qaaday",
      "animalEventID": "Aqoonsiga Dhacdada Xayawaanka",
      "cANCEL": "Jooji",
      "cONFIRM": "Xaqiiji",
      "sTATEMENT": "Ma hubtaa inaad doonayso inaad tirtirto diiwaankan?",
      "dAY": "Maalinta",
      "wEEK": "Todobaadka",
      "mONTH": "Bisha",
      "sUBMIT": "Gudbi",
      "startDate": "Taariikhda billowga",
      "endDate": "Taariikhda dhamaadka",
      "rEPEAT": "Ku celi",
      "taskCategory": "Qaybta Hawsha",
      "pRIORITY": "Mudnaanta",
      "aSSIGNEE": "Magacaabid",
      "selectLocation": "Dooro goobta",
      "selectAnimals": "Dooro hal ama dhowr xayawaan",
      "dESCRIPTION": "Sharaxaada",
      "customRecurrence": "Soo noqnoqoshada caadada",
      "repeatEvery": "Ku celi mid kasta",
      "taskName": "Magaca hawsha",
      "enterDescription": "Geli Sharaxaada",
      "toDo": "In la Sameeyo",
      "assignTo": "U qoondee",
      "status": "Xaalada",
      "nOTE": "Ogow",
      "noTaskAvailable": "SHAQO MA HAYSAAN",
      "healthRecord": "Diiwaanka Caafimaadka",
      "iD": "aqoonsi",
      "tAG": "Tag",
      "dateOfbirth": "Taariikhda Dhalashada",
      "taskTakenat": "Hawsha La Qabtay",
      "gENDER": "Jinsiga",
      "bREED": "Taranka",
      "regDate": "Reg. ",
      "updateHealthRecord": "Cusbooneysii Diiwaanka Caafimaadka ee Xoolaha",
      "treatment": "Daawaynta",
      "reasonOftreatment": "Sababta Daawaynta",
      "treatmentDate": "Taariikhda daawaynta",
      "dIAGNOSIS": "ogaanshaha",
      "drugId": "Aqoonsiga daroogada",
      "drugName": "Magaca daroogada",
      "drugWithdrawalperiod": "Muddada ka bixida daroogada",
      "attendingVeterinarian": "Imaanshaha dhakhtarka xoolaha",
      "packId": "Xidhmada aqoonsiga",
      "noItemsselected": "Ma jiraan wax la doortay",
      "healthRecordsubmission": "Soo Gudbinta Diiwaanka Caafimaadka",
      "inseminationRecordsubmission": "Gudbinta-Diiwaangelinta",
      "inseminatorName": "Magaca Inseminator",
      "inseminatorId": "Aqoon-isweydaarsiga aqoonsiga",
      "conceptionRate": "Heerka ra'yiga",
      "dateOfmeasurement": "Taariikhda Qiyaasta",
      "recordSubmission": "Soo gudbinta diiwaanka",
      "uPDATE": "Cusbooneysii",
      "updateTask": "Cusbooneysii Hawsha"
    },
    "inseminatorStatisticsInfo": {
      "addInseminatorInfo": "Kudar Macluumaadka Inseminator",
      "inseminatorNumber": "Lambarka wacyigelinta",
      "loadingInseminatorPleaseWait": "Soodejinaya Inseminator... Fadlan sug",
      "searchByIDAndName": "Ku raadi Aqoonsi iyo Magaca",
      "inseminatorInfoAdded": "Macluumaadka Inseminator Lagu daray",
      "inseminatorInfoNotAdded": "Macluumaadka Inseminator Laguma Darin",
      "inseminatorInfoUpdated": "Xogta wacyigelinta waa la cusboonaysiiyay",
      "inseminatorInfoNotUpdated": "Xogta wacyigelinta lama cusboonaysiin",
      "editAInseminatorInfo": "Wax ka beddel xogta wacyigelinta",
      "inseminatorList": "Liiska Inseminators",
      "inseminatorInfoDetails": "Faahfaahinta Macluumaadka Inseminator",
      "updateInseminatorInfo": "Cusbooneysii Macluumaadka Inseminator"
    },
    "organizationNtrInfo": {
      "loadingOrdersPleaseWait": "Soodejinaya Dalabka... Fadlan sug",
      "addStocks": "Ku dar kayd",
      "addStock": "Ku dar kayd",
      "quantity": "Tirada",
      "selectUnit": "Xulo Unug",
      "farmProducts": "Alaabooyinka Beeraha",
      "cost": "Qiimaha",
      "transactionID": "Aqoonsiga wax kala iibsiga",
      "recipientID": "Aqoonsiga qaataha",
      "orderID": "Dalbashada aqoonsiga",
      "recepientName": "Magaca qaabilaadda",
      "createAOrder": "Abuur amar",
      "totalStocks": "Wadarta kaydka",
      "orders": "Dalabka",
      "totalPending": "Wadarta guud ee la sugayo",
      "totalDelivered": "Wadarta la keenay",
      "searchByRecepientNameOrderIdRecepientId": "Ku baadh Magaca Soo-dhoweeyaha, Aqoonsiga Dalabka, Aqoonsiga Soo-dhawaynta",
      "chooseTheDate": "Dooro taariikhda",
      "transactionDate": "Taariikhda wax kala iibsiga",
      "selectCategory": "Dooro Qaybta",
      "volumeOfProduct": "Mugga Alaabta",
      "productQuantity": "Tirada alaabta",
      "productRecipientId": "Aqoonsiga qaataha alaabta",
      "productRecipientName": "Magaca qaataha alaabta",
      "productRecipientType": "Nooca qaataha alaabta",
      "singleProduct": "Alaabta Keliya",
      "orderPlaced": "Dalabka La Dhigay",
      "orderNotPlaced": "Dalabka Lama Dhigin",
      "totalPrice": "Wadarta Qiimaha",
      "currency": "Lacagta",
      "selectCurrency": "Dooro Lacagta",
      "address": "Cinwaanka",
      "enterAddress": "Gali Ciwaanka",
      "attachments": "Lifaaqa",
      "chooseFile": "Dooro File",
      "nameOfTheFarm": "Magaca beerta",
      "loremIpsumHasBeenTheIndustrySStandardDummyText": "Lorem Ipsum wuxuu ahaa qoraalka caadiga ah ee warshadaha ilaa iyo 1500-meeyadii, markii daabacaad aan la garanayn uu qaatay",
      "billedTo": "Lagu Dalacsiiyay",
      "orderStatus": "Xaalada Dalbashada",
      "selectStatus": "Dooro Xaaladda",
      "cadbury": "Cadbury",
      "totalAmount": "Wadarta tirada",
      "deliveryCharges": "Kharashka Bixinta",
      "orderDetails": "Faahfaahinta Dalabka",
      "deliveryOnTime": "Bixinta wakhtiga",
      "productID": "Aqoonsiga alaabta",
      "productRegistration": "Diiwaangelinta Alaabta",
      "enterTheNameOfTheProduct": "Geli magaca alaabta",
      "nameOfTheProduct": "Magaca Alaabta",
      "productAdded": "Badeecada lagu daray",
      "productNotAdded": "Alaabada Laguma Darin"
    },
    "drug": {
      "dRUGS": "Daawooyinka",
      "registerAdrug": "Diiwaangeli Daawo",
      "sEARCH": "Raadi",
      "genericName": "Magaca Guud",
      "manufacturer": "Soo saaraha",
      "distributor": "Qaybiyaha",
      "registrationDate": "Taariikhda Diiwaangelinta",
      "drugRegistration": "Diiwaangelinta Dawada",
      "drugInformation": "Macluumaadka Dawooyinka",
      "packExpiration": "Xidhmada dhicitaanka",
      "drugId": "Aqoonsiga daawada",
      "drugName": "Magaca daroogada",
      "drugGenericname": "Magaca Guud ee Dawooyinka",
      "drugManufacturer": "Soo saaraha daroogada",
      "distributorName": "Magaca Qaybiyaha",
      "drugRegistrationdate": "Taariikhda Diiwaangelinta Dawada",
      "nextDrug": "Daawooyinka Xiga",
      "editDrug": "Wax ka beddel daawada",
      "updateDrug": "Cusbooneysii Dawooyinka",
      "deleteDrug": "Tirtir Daawooyinka",
      "noRecordfound": "Wax Diiwaan ah lama helin",
      "addDrug": "Daroogada ku dar",
      "statementDrug": "Daawada waa la tirtiray  ",
      "cANCEL": "Jooji",
      "cONFIRM": "Xaqiiji",
      "sTATEMENT": "Ma hubtaa inaad doonayso inaad tirtirto diiwaankan?",
      "ok": " ok",
      "information": "Xog",
      "packOrder": "Dalabka Xidhmada",
      "packPrescription": "Xidhmada Dawada",
      "packReservation": "Boos sii qabsiga",
      "packLocation": "Goobta Xidhmada",
      "drugDozedam": "Qiyaasta maandooriyaha ee maalintii loogu talagalay Dam",
      "drugDozecalf": "Qiyaasta maandooriyaha ee maalintii ee Kubka",
      "drugFormate": "Qaabka Dawooyinka",
      "drugDistributor": "Qaybiyaha daroogada",
      "drugActiveingridents": "Maaddooyinka firfircoon ee daroogada",
      "drugSubstitutionId": "Aqoonsiga beddelka daroogada",
      "packId": "Xidhmada aqoonsiga",
      "packBatchNumber": "Xidhmada Lambarka Dufcada",
      "drugIdStatement": "Tirada dufcada ee dawada.",
      "drugNameSatement": "Magaca summada la xayaysiiyay ee daawada lagu iibiyo.",
      "drugGenericnameStatement": "Qurxinta kiimikaad ee daawada halkii laga isticmaali lahaa magaca astaanta la xayeysiiyay ee daawada lagu iibiyo.",
      "drugFormateSatement": "Tirada dufcada ee dawada.",
      "drugDozecalfSatement": "Si loo ogaado qiyaasta qiyaasta daawada ee kubka.",
      "drugDozedamStatement": "Si loo ogaado qiyaasta qiyaasta daawada ee biyo-xidheenka.",
      "drugManufacturerStatement": "Faahfaahinta soo saaraha dawada.",
      "drugDistributorStatement": "Faahfaahinta qaybiyaha dawada.",
      "drugRegistrationdateStatement": "Taariikhda diiwaan gelinta daroogada ee dalka gaarka ah.",
      "drugActiveingridentsStatement": "Liiska maaddooyinka firfircoon.",
      "drugSubstitutionIdStatement": "Aqoonsiga beddelka suurtagalka ah ee dawada haddii ay dhacdo in dawada ugu weyni aanay hadda diyaar ahayn.",
      "packIdStatement": "Bar code ama RF ID ee xirmada.",
      "packBatchNumberStatement": "Nambarka dufcadda uu u qoondeeyay xirmada soo saaraha.",
      "locationWarehouseID": "Goobta Aqoonsiga Warehouse",
      "locationWarehouseIDState": "Aqoonsiga bakhaarka meesha baakadu ku kaydsan tahay.",
      "locationRackID": "Aqoonsiga Rack goobta",
      "locationRackIDStatement": "Aqoonsiga raafka meesha baakadu ku kaydsan tahay.",
      "locationTierID": "Aqoonsiga Heerka Goobta",
      "locationTierIDStatement": "Aqoonsiga darajada raandada meesha baakadu ku kaydsan tahay.",
      "locationPositionID": "Aqoonsiga Booska Goobta",
      "locationPositionIDStatement": "Aqoonsiga booska ku yaal heerka baakadka lagu kaydiyo.",
      "storageTemperatureCondition": "Xaalada Heerkulka Kaydinta",
      "storageTemperatureConditionStats": "Xaaladda kaydinta baakadaha.",
      "containerForm": "Foomka weelka",
      "containerFormStatement": "Qaabka weelka ay ku jirto dawada.",
      "consistQuantity": "Ka Kooban Yahay",
      "consistQuantityStatement": "Tirada kaniiniyada, dhalooyinka, iwm ee xirmada.",
      "releaseId": "Siideynta aqoonsiga",
      "releaseIdStatement": "Aqoonsiga kaas oo loo qoondeeyay ka dib xirmada uu qaato beeralayda.",
      "releaseDate": "Taariikhda lagu sii daynayo",
      "releaseDateStatement": "Taariikhda markii baakadka laga qaaday beeralayda.",
      "packManufacturedDate": "Xidhmada Taariikhda la sameeyay",
      "packManufacturedDateStatement": "Taariikhda marka xirmada la soo saaray.",
      "packImportedDate": "Xidhmada Taariikhda La Soo Dejiyay",
      "packImportedDateStatement": "Taariikhda markii xirmada la soo dejiyay",
      "packExpirationDate": "Xidhmada Taariikhda uu dhacayo",
      "packExpirationDateStatement": "Taariikhda marka baakidhku dhacayo.",
      "expiredSoonFlag": "Dhawaan wuu dhacay Calanka",
      "expiredSoonFlagState": "Digniin ku saabsan baakidhku wuu dhacayaa dhawaan.",
      "packTotalVolumeLeft": "Xidhmada wadarta mugga bidix",
      "packTotalVolumeLeftState": "Wadarta tirada xirmooyinka leh maaddooyinka isku midka ah ee kaydka ku haray.",
      "packOrderID": "Xidhmada Dalabka Aqoonsiga",
      "packOrderIDState": "Aqoonsiga kaas oo la qoondeeyay ka dib markii laga dalbado baakadda qaybiyaha.",
      "packQuantityOrdered": "Tirada Xidhmada La Dalbaday",
      "packQuantityOrderedState": "Tirada xirmooyinka oo laga dalbaday qaybiyaha",
      "packPrice": "Qiimaha Xidhmada",
      "packPriceStatement": "Qiimaha xirmada.",
      "priceCurrency": "Lacagta Qiimaha",
      "packPricecurrency": "Xidhmada Qiimaha Lacagta",
      "packPricecurrencyState": "Magaca lacagta ee qiimaha lagu magacaabay.",
      "packPaydate": "Xidhmada Taariikhda Lacag bixinta",
      "payDate": "Taariikhda Bixinta",
      "packPaydateState": "Taariikhda marka lacagta la sii daayo qaybiyaha.",
      "packShippingID": "Xidhmada Aqoonsiga dhoofinta",
      "shippingID": "Aqoonsiga dhoofinta",
      "packShippingIdState": "Aqoonsiga rarida ee xirmada marka laga yimaado qaybiyaha",
      "packShippingDate": "Taariikhda Baakadaha",
      "shippingDate": "Taariikhda dhoofinta",
      "packShippingDateState": "Taariikhda imaatinka xirmada ee kaydka.",
      "packOrderStatus": "Heerka Dalabka Xidhmada",
      "packOrderStatusState": "Xaaladda amarka hadda jira.",
      "recepientKeeperId": "Aqoonsiga Kaydka Soo Dhawaynta",
      "recepientKeeperIdStatement": "Magaca qofka/ururka helay xirmada.",
      "recepientFarmId": "Aqoonsiga Beerta Soo dhawaynta",
      "recepientFarmIdStatement": "Aqoonsiga beerta uu ka tirsan yahay maandooriyaha xayawaanka ah.",
      "recepientAnimalId": "Aqoonsiga Xoolaha qaabilaadda",
      "recepientAnimalIdState": "Aqoonsiga neefka loo qoray daawada (baakada)",
      "specialistComments": "Faallooyinka Khaaska ah",
      "specialistCommentsState": "Faallooyin ku saabsan dhakhtarka xoolaha ee takhasuska leh.",
      "specialistName": "Magaca Takhasuska",
      "specialistNameState": "Magaca takhtarka takhasuska leh/dhakhtarka xoolaha u qoray daawada.",
      "specialistID": "Aqoonsiga takhasuska",
      "specialistIDState": "Aqoonsiga takhasusaha/dhakhtarka xoolaha ee qoray daawada.",
      "reservedByKeeperId": "Waxaa xafiday Aqoonsiga Kaydka",
      "reservedByKeeperIdState": "Aqoonsiga ilaaliye ee cidda kaydisay baakidhka.",
      "reservedByFarmId": "Waxaa xafiday Aqoonsiga Beerta",
      "reservedByFarmIdState": "Aqoonsiga beerta kaas oo baakadka loo sii dhigay.",
      "reservationTimeoutDate": "Boos sii qabsiga Taariikhda Wakhtiga",
      "reservationTimeoutDateState": "Taariikhda marka boos celinta si toos ah loo tirtiri doono haddii baakadda aan la iibsan.",
      "reservationTimeout": "Boos sii qabsiga wakhtiga",
      "reservationTimeoutState": "Tirada saacadaha ka dib boos qabsiga si toos ah ayaa loo burin doonaa haddii baakadda aan la iibsan ama aan la qaadin",
      "reservationDate": "Taariikhda Booska",
      "reservationDateState": "Taariikhda sii qabsashada xirmada",
      "reservationStatus": "Xaaladda Boos sii qabsiga",
      "reservationStatusState": "Heerka sii qabsashada xirmada ",
      "loadingDrugsPleaseWait": "Soodejinaya Dawooyinka... Fadlan sug",
      "quantityOrder": "Dalabka tirada",
      "keeperID": "Aqoonsiga haye",
      "timeoutDate": "Taariikhda Wakhtigu",
      "warehouseID": "Aqoonsiga bakhaarka",
      "rackID": "Aqoonsiga Rack",
      "tierID": "Aqoonsiga heerka",
      "positionID": "Aqoonsiga booska",
      "temperatureCondition": "Xaaladda Heerkulka",
      "manufactureDate": "Taariikhda wax-soo-saarka",
      "importedDate": "Taariikhda la soo dhoofiyay",
      "totalVolumeLeft": "Wadarta mugga bidix"
    },
    "reports": {
      "myReports": "Warbixinadeyda",
      "satelliteReports": "Warbixinada Satellite-ka",
      "weatherReports": "Warbixinada Cimilada",
      "pregnancyAnalytics": "Falanqaynta Uurka",
      "semenEmbroyAnalytics": "Falanqaynta shahwada/Urjiifka",
      "semenAnalytics": "Falanqaynta shahwada",
      "embryoAnalytics": "Falanqaynta Embryo",
      "calfAnalytics": "Falanqaynta kubka",
      "milkProduction": "Soo saarista caanaha",
      "totalMilkType": "Wadarta Nooca caanaha",
      "totalAnimalAnalytics": "Wadarta Falanqaynta Xoolaha",
      "animalAnalytics": "Falanqaynta Xoolaha",
      "analyticsAndReporting": "Falanqaynta iyo Warbixinta",
      "filterByCountry": "Ku Shaandhee Dal ahaan",
      "filterByFarm": "Sifee Beerta",
      "filterByRegion": "Ku sifey Gobolka",
      "filterByMonth": "Sifee Bisha",
      "filterByDate": "Ku Shaandhayso Taariikhda",
      "filterByRole": "Ku Shaandhee Doorka",
      "filterByYear": "Sifee Sannadka",
      "filterByTrait": "Ku sifey Sifada",
      "avgBreedingValue": "Celceliska Qiimaha Taranka",
      "avgEconomicIndex": "Celceliska Tusmada Dhaqaalaha",
      "breederReport": "Warbixinta Taranka",
      "semenTransferDate": "Taariikhda Gudbinta shahwada",
      "semenEmbryoProductionReport": "Warbixinta Wax-soo-saarka shahwada/Ereysiga",
      "semenProducts": "Alaabta shahwada",
      "meatProducts": "Alaabta Hilibka",
      "totalProducts": "Wadarta Alaabta",
      "semenEmbryoReport": "Warbixinta shahwada/Ereysiga",
      "numOfStraws": "Tirada cawska",
      "collectionDate": "Taariikhda Ururinta",
      "productionReport": "Warbixinta Wax Soo Saarka",
      "receipientId": "Aqoonsiga qaataha",
      "embryoId": "Aqoonsiga embriyaha",
      "semenStrawId": "Aqoonsiga shahwada shahwada",
      "dataScientist": "Saynisyahanka Xogta",
      "dataScientistReport": "Warbixinta Saynisyahanka Xogta",
      "productReport": "Warbixinta Alaabta",
      "dairyProducts": "Alaabta caanaha"
    },
    "genoPerformance": {
      "performanceOfGenoType": "Waxqabadka GenoType",
      "addAGenoType": "Kudar GenoType",
      "breedName": "Magaca taranka",
      "chromosome": "Chromosome",
      "sequenceChange": "Isbeddelka Taxanaha",
      "inheritance": "Dhaxalka",
      "diseaseName": "Magaca Cudurka",
      "referenceSequence": "Tixraaca Tixraaca",
      "pubmedReference": "Tixraaca la daabacay",
      "genoTypeRegistration": "Diiwaangelinta GenoType",
      "breed": "Taranka",
      "editAGenoType": "Tafatir GenoType",
      "editGenoType": "Wax ka beddel GenoType",
      "loadingGene": "Soodejinaya Geno... Fadlan sug",
      "geneTypeList": "Liiska GenoType"
    },
    "reportings": {
      "conception": "Fikradda (Saynisyahanka Xogta)",
      "performanceOfGenoData": "Waxqabadka Genotype (Saynisyahanka Xogta)",
      "totalInsemination": "Isku-darka Dhalinta",
      "embryo": "Embriyo",
      "animalVaccinationRecord": "Diiwaanka Tallaalka Xoolaha",
      "dataNotAvailable": "Xogta Looma hayo Beertan",
      "pregnancyStatus": "Xaaladda Uurka",
      "healthReport": "Warbixinta Caafimaadka",
      "heavyMilk": "Caano Culus",
      "standardMilk": "Caano Caadiga Ah"
    },
    "sidebar": {
      "healthAnalytics": "Falanqaynta Caafimaadka",
      "productionAnalytics": "Falanqaynta wax soo saarka"
    },
    "epd": {
      "regNo": "Animal Reg Maya waa koodka gaarka ah ee la siiyo xayawaanka iyadoo la adeegsanayo hab calaamadayn, hubinta habka loo sameeyo si loo aqoonsado loona dabagalo xayawaanka gaarka ah",
      "internationalID": "Aqoonsiga Caalamiga ah ee Xayawaanka",
      "location": "Dalka / Gobolka Xoolaha ",
      "animalName": "Magaca caadiga ah / Magacaabista Xayawaanka",
      "gender": "Galmada xoolaha (lab/dheddig)",
      "additionalIDMethod": "Qaabkee ayaa loo isticmaalay in lagu aqoonsado xayawaanka (tusaale dhegta summada, tattoo)",
      "damID": "Aqoonsiga ama nambarka diiwaangelinta ee biya-xireenka xoolaha - haweeneyda waalidka ah ee xayawaanka / aqoonsiga tirada hooyada dhashay",
      "sireId": "Aqoonsiga ama nambarka Diiwaangelinta ee waalidka lab ee xoolaha, gaar ahaan dibiga lagu hayo taranka ama shahwada dibida ee loo isticmaalo baridda macmalka ah.",
      "dateOfBirth": "Taariikhda dhalashada xayawaanka.",
      "breederHerdCode": "Xeerka adhiga dhaq-dhaqaaqa inta badan waxaa bixiya Ururada taranka",
      "seasonofBirth": "Xiliga Dhalashada Xoolaha ayaa la xusay bisha",
      "birthYear": "Sannadkii neefku dhashay",
      "birthManagementCode": "Xeerka Maareynta Dhalashada inta badan waxaa bixiya isticmaale/ beeraley",
      "birthSex": "Jinsiga xoolaha (lab/dheddig)",
      "birthWeight": "Miisaanka Dhalashada ee Kubka ",
      "primaryBreed": "Ugu weyn % waxtarka hidde-sidaha xayawaanka ",
      "secondaryBreed": "Wax yar % ka qaybgalka hidde-sidaha xayawaanka ",
      "breedComposition": "Boqolkiiba hal-abuurka taranka waxa loola jeedaa saami qaybsiga noocyada kala duwan ee noocyada kala duwan ee qurxinta hidde-sidaha ee xayawaan shakhsi ah ama koox xayawaan ah. ",
      "conceptionMethod": "Sida xayawaanku u uuraystay (u-guursi dabiici ah/ bacrin/wareejin embriyaha).",
      "accuracyWeight": "Miisaanka Saxda ah",
      "damAge": "Da'da biyo-xidheenka bilaha/sanadaha tusaale. ",
      "weaningWeight": "Naaska naaska Miisaanka xoolaha wakhtiga naaska.",
      "weaningDate": "Taariikhda neefka naaska laga jaray",
      "weaningSex": "Galmada neefka naaska laga saaray. ",
      "managementPastureCode": "Xeerka la siiyo maamulka/ daaqa ee isticmaala/ beeralayda ",
      "creep": "Quudinta gurguurta waa dhaqanka siinta quudka dheeriga ah (hadhuudhka ama calafka) ee weylaha kalkaalinta.",
      "weaningContemporaryGroupCode": "Kooxda Casriga ah ee Miisaanka Goynta Naaska",
      "birthContemporaryCode": "Dhalashada Xeerka Casriga ah",
      "yearlingDate": "Taariikhda neefka jira hal sano ama sanadka labaad ee da'diisa",
      "managementFeedUnitCode": "Koodhka la siiyo qaybta maamulka/ quudinta isticmaaluhu",
      "yearlingSex": "Jinsiga xayawaanka wakhtiga sanadka ",
      "yearlingWeight": "Miisaanka Sannadlaha waa cabbiraadda koritaanka tooska ah ee naaska ka dib waxaana badanaa loo isticmaalaa in lagu muujiyo waxqabadka suurtagalka ah ee faraca suuqa ku xiran ee quudinta, oo lagu qiyaaso rodol oo dibi ah.",
      "yearlingHeight": "Dhererka xayawaanka wakhtiga sanadka ",
      "yearlingWeightContemporaryGroupCode": "Kooxda Casriga ah ee Miisaanka Sannadka",
      "weaningYearlingWeightContemporaryGroupCode": "koodhka Naaska ama Kooxda Casriga ah ee Miisaanka Sannadka",
      "daysOnFeed": "Tirada maalmood ee la quudiyo quudintaas gaarka ah Ex: lo'da yar yar ee koraysa waxaa lagu quudiyaa cunto tamar badan si ay u soo saaraan hilibka lo'da ee la suuq-geyn karo oo qiimo jaban laga helayo. ",
      "managementFeedUnitPenCode": "Koodhka la siiyo maamulka/qaybta quudinta/qalinka isticmaalaha",
      "harvestDate": "Taariikhda xoolaha la gowracay (la dilay) hilibka",
      "gradingDate": "Taariikhda meydadka waxaa lagu qiimeeyay si waafaqsan shuruudo gaar ah",
      "carcassSex": "Galmada bakhtiga",
      "dateonFeed": "Taariikhda neefka loo wareejiyay quud cusub Ex: lo'da yar yar ee koraysa waxaa lagu quudiyaa cunto tamar badan leh si ay u soo saaraan hilibka lo'da ee suuqa laga heli karo qiimo jaban oo faa'iido ah. ",
      "KPH": "% KPH waa boqolkiiba wadarta dufanka laga helo daloolka jidhka ee bakhtiga gaar ahaan gobollada kelyaha, miskaha, iyo wadnaha. ",
      "carcassWeight": "Miisaanka bakhtigu waa miisaanka kulul ama aan la qaboojin ka dib goosashada iyo ka saarida maqaarka, madaxa, mareenka caloosha iyo mindhicirka, iyo xubnaha gudaha. ",
      "fatThickness": "Dhumucda baruurta waxa lagu cabbiraa inji iyadoo la isticmaalayo mastarad yar. ",
      "marbling": "Marbling waa dufan muruqa ah oo muuqda oo aan dheregsanayn (caafimaad leh) kaas oo ku urura gudaha muruqa iyo inta u dhaxaysa xidhmooyinka fiber muruqa.",
      "ribeyeArea": "Qadarka feeraha isha (jidhka ama murqaha ribeye longissimus dorsi) oo lagu cabbiro inta u dhaxaysa feeraha 12aad iyo 13aad ee injis laba jibaaran iyadoo la isticmaalayo shabag (tusaale, 8, 9 ama 10 inches). ",
      "animalStatus": "Xaaladda xoolaha ee beerta tusaale: caafimaad qaba, buka iwm"
    },
    "manageAnimalGroupings": {
      "resetModeTooltip": "\n        NIDAAMKA DIB U DEJINTA <br>\n            Habkan <br>\n            1) Deji/ qeex dhammaan sifooyinka kooxaha casriga ah (CGs) ee dhammaan sifooyinka xiisaha leh. <br>\n            2) U qoondee dhammaan xayawaanka CG u dhigma. <br>\n            3) Haddii meelaynta xooluhu ku qanci waydo, hagaaji/bedesho CG-yada, ka dibna mar kale xoolaha ku wareeji CG-yada cusub ee u dhigma. <br>\n            4) Ku celi tillaabooyinka kor ku xusan, haddii loo baahdo, ilaa aad ku qanacdo CG-yada iyo kooxaynta/ qoondaynta xoolaha ee u dhiganta.<br>\n        ",
      "maintainanceModeHeadingTooltip": "Marka RESET (habka) la dhammeeyo, waxaad geli doontaa Habka Dayactirka halkaas oo EDP-yada lagu xisaabiyo RESET ay si joogto ah ugu hayn doonaan xayawaan kasta ilaa dib-u-dejinta soo socda (oo laga yaabo inay 2-6 bilood ka hadhsan yihiin). ",
      "maintainanceModeTooltip": "Kadib markaad dhamaystirto DIB U SAMEYNTA HABKA, riix batoonka DIB U SAMEYNTA DHAMMAAN si aad awood ugu siiso nidaamka inuu xisaabiyo EPD-yada xayawaanka oo dhan, Jooji NIDAAMKA DIB U SAMEYNTA, oo billow Habka Dayactirka.",
      "resetToggleTooltip": "Daar dib u dajinta Beddelka qaabka EPD si aad xoolaha ugu meelayso CG-yada."
    },
    "geneticsAndBreeding": {
      "geneticsAndBreeding": "Hidde-yaqaanka",
      "geneticSearchTool": "Qalabka Raadinta Hiddaha",
      "dataSubmission": "Soo Gudbinta Xogta / Xulashada Xoolaha",
      "animalsWithExpectedProgenyDifferences": "Xulashada Xayawaanka ee Xisaabinta Farqiga Farcanka La Filayo (EPDs).",
      "searchByAnimalIdName": "Ku raadi Aqoonsiga Xayawaanka, Magaca",
      "rowsPerPage": "Safka boggiiba",
      "individualEntry": "Gelitaanka Shakhsi ahaaneed",
      "bulkEntry": "Gelitaanka badan",
      "registerANewAnimalOrSelectAnExistingAnimal": "Diiwaangeli neef cusub ama dooro xayawaan jira.",
      "registerNewAnimal": "Diiwaangeli Xayawaanka Cusub",
      "selectExistingAnimal": "Dooro Xayawaanka Jirta",
      "animalID": "Aqoonsiga xoolaha",
      "animalName": "Magaca Xoolaha",
      "tag": "Tag",
      "dateOfBirth": "Taariikhda Dhalashada",
      "gender": "Jinsiga",
      "birthDate": "Taariiqda dhalasha",
      "birthWeightLb": "Miisaanka Dhalashada (lb)",
      "birthWeightKg": "Miisaanka Dhalashada (kg)",
      "weaningWeightLb": "Miisaanka naaska naaska (lb)",
      "weaningWeightKg": "Miisaanka naaska naaska (kg)",
      "yearlingWeightLb": "Miisaanka Sannadka (lb)",
      "yearlingWeightKg": "Miisaanka Sannadka (kg)",
      "carcassWeightLb": "Miisaanka Bakhtiga (lb)",
      "carcassWeightKg": "Miisaanka Bakhtiga (kg)",
      "animalSelection": "Xulashada Xoolaha",
      "animalSearchTool": "Qalabka Raadinta Xoolaha",
      "back": "Dib u noqo",
      "searchByEPDs": "Raadi EPDs",
      "searchByIds": "Ku baadh Iids",
      "selectBreed": "Dooro taranka",
      "selectGender": "Dooro Jinsiga",
      "selectRequiredBreedForCattle": "Lo'da u dooro taranka looga baahan yahay",
      "resetFilter": "shaandhaynta dib u dajin",
      "birthWeightHeader": "Miisaanka Dhalashada (BW): ",
      "birthWeightDef": "Wuxuu barbar dhigayaa kala duwanaanshaha miisaanka weylaha marka ay dhashaan waxaana lagu cabbiraa rodol ama kg.",
      "weaningWeightHeader": "Miisaanka naaska naaska (WW): ",
      "weaningWeightDef": "WW EPD waa qiyaasta koritaanka naaska ka horraysa oo lagu qiyaaso rodol ama kg.",
      "yearlingWeightHeader": "Miisaanka Sannadka (YW): ",
      "yearlingWeightDef": "YW EPD waa qiyaasta koritaanka naaska ka dib taas oo lagu qiyaaso rodol ama kg.",
      "ribEyeAreaHeader": "Aagga Ribeeye(REA): ",
      "ribEyeAreaDef": "REA waxay cabbirtaa cabbirka muruqa ee na siiya ribeeye ee injis laba jibaaran. REA EPDs waxay ka tarjumaysaa kala duwanaanshaha cabbirka aagga ribeeye ee 365-maalmood la hagaajiyay oo ku salaysan cabbirada bakhtiga ee lo'da la goostay.",
      "marblingHeader": "Marbling (MARB): ",
      "marblingDef": "MARB EPD waxay ku jirtaa halbeegyada boqolkiiba baruurta muruqyada gudaha gudaha ribeye.MARB EPDs waxay ka tarjumaysaa kala duwanaanshiyaha dhibcaha 365-maalin ee marbling (dufan gudaha ah, [IMF]) oo ku salaysan cabbirada hilibka lo'da la goostay.",
      "fatThicknessHeader": "Dufanka Dufanka (Fat): ",
      "fatThicknessDef": "Inches ee dufanka dhabarka (boqollaal ee inch) waa unugga cabbiraadda FT.",
      "carcassWeightHeader": "Miisaanka Bakhtiga (CW): ",
      "carcassWeightDef": "Miisaanka bakhtigu waa sifo faa'iido leh marka la tixgeliyo saameynta uu rodolku leeyahay marka loo eego dhammaadka qiimaha alaabta. ",
      "yieldGradeHeader": "Heerka Wax-soosaarka (YG): ",
      "yieldGradeDef": "Nidaamka buundooyinka Wax-soosaarka USDA waa unugga cabbiraadda YG EPD. ",
      "milkHeader": "Caano (MK): ",
      "milkDef": "MK EPD waxaa lagu qiyaasaa rodol oo ah miisaanka naaska naaska ee kubka sababtoo ah awoodda caanaha hooyada.",
      "totalMaternalHeader": "Wadarta Hooyada (TM): ",
      "totalMaternalDef": "TM waxay cabbirtaa saamaynta miisaanka naaska kubka sababtoo ah wax-soo-saarka caanaha iyo hiddaha lo'da ee koritaanka labadaba.",
      "calvingEaseDirectHeader": "Fududeynta Dhalmada Tooska ah (CED): ",
      "calvingEaseDirectDef": "CED EPD waxay ku taxan tahay boqolkiiba dhalmada aan la caawin.",
      "calvingEaseMaternalHeader": "Fududeynta Dhalmada Hooyada (CEM): ",
      "calvingEaseMaternalDef": "Wuxuu cabbiraa awoodda hablaha dibigu u leeyihiin weylaha aan la kaalmayn markay laba sano jiraan.",
      "stayabilityHeader": "Joogitaan (JOOG): ",
      "stayabilityDef": "ST EPD waxa ay saadaalisaa awoodda dibi uu u eryi karo lo'da \"joogta agagaarkeeda\". ",
      "docilityHeader": "Docility (DOC): ",
      "docilityDef": "DOC waxay cabbirtaa dabeecadda lo'da.",
      "max": "MAX",
      "min": "MIN",
      "accuracy": "SAX AH",
      "sortBy": "Kala saar",
      "traits": "Sifooyin lagu soo bandhigay cawl ayaa ku socda horumar, kuwaas oo imanaya Q2, 2023.",
      "searchResults": "Natiijooyinka raadinta",
      "recordsFound": "diiwaanada la helay",
      "compareSelected": "IS barbar dhig la doortay",
      "animalIdentification": "Aqoonsiga Xoolaha",
      "errorMessage": {
        "birthWeight": "Qiimaha ugu badan ee miisaanka dhalashada kama yaraan karo miisaanka ugu yar ee dhalashada",
        "weaningWeight": "Miisaanka naaska ka goynta qiimaha ugu badan kama yaraan karo miisaanka ugu yar ee naaska naaska",
        "yearlingWeight": "Qiimaha ugu badan ee miisaanka sanadka kama yaraan karo miisaanka ugu yar ee sanadka",
        "carcassWeight": "Miisaanka bakhtigu qiimaha ugu badan kama yaraan karo miisaanka ugu yar ee Dhalashada",
        "fatThickness": "Dhumucda baruurta qiimaha ugu badan kama yaraan karo miisaanka ugu yar ee naaska",
        "marbling": "Marbling qiimaha ugu badan kama yaraan karo miisaanka ugu yar ee Sannadlaha",
        "ribeyeArea": "Aagga Ribeeye Qiimaha ugu badan kama yaraan karo miisaanka ugu yar ee Dhallaanka",
        "yieldGrade": "Waxsoosaarka Fasalka ugu badan kama yaraan karo miisaanka ugu yar ee naaska",
        "milk": "Qiimaha ugu badan ee caanuhu kama yaraan karo miisaanka ugu yar ee naaska"
      },
      "reg": "Reg",
      "name": "Magaca",
      "sex": "Galmada",
      "tattoo": "Tattoo",
      "dob": "DOB",
      "EPD": "EPD",
      "rank": "Darajo",
      "searchValue": "Raadi Qiimaha",
      "typeHere": "Halkan ku qor",
      "searching": "Raadinta...",
      "fetchingResult": "Keenaya natiijooyinka...Fadlan sug",
      "animalsMatchedYourCriteria": "Xayawaanku waa waafajiyeen shuruudahaaga",
      "manageAnimalsGrouping": "Maamul kooxaynta Xoolaha",
      "manageAnimalGroupings": "Maamul kooxaynta Xoolaha",
      "assignAnimalToContemporaryGroups": "U qoondee Xoolaha Kooxo Casri ah",
      "resetMode": "Qaabka dib u dajinta",
      "enterResetMode": "Geli Qaabka Dib u Dajinta",
      "maintainanceMode": "Habka Dayactirka",
      "assigningAnimals": "Qoondaynta Xoolaha",
      "excludedAnimals": "Xayawaanka laga saaray",
      "ungroupedAnimals": "Xayawaanka aan la ururin",
      "assignAnimalsToCGS": "U qoondee Xoolaha CGS",
      "reset": "Dib u dajin",
      "excludeAnimals": "Ka Reebo Xoolaha",
      "resetToMaintainanceMode": "Dib u dajin waa la dhameeyay - U beddel qaabka dayactirka",
      "contemporaryGroupsSettings": "Dejinta Kooxaha Casriga ah (CG).",
      "selectTrait": "Dooro Sifada",
      "selectTraitDescription": "Dooro sifo waxa loola jeedaa habka doorashada sifo gaar ah",
      "traitsType": {
        "birthWeight": "Miisaanka Dhalashada",
        "weaningWeight": "Miisaanka naaska naaska",
        "yearlingWeight": "Miisaanka sanadka",
        "carcassWeight": "Miisaanka Bakhtiga"
      },
      "addNewGroup": "KOOX CUSUB KU darso",
      "contemporaryGroup": "Kooxda Casriga ah",
      "contemporaryGroups": "Kooxaha Casriga ah",
      "editGroup": "Kooxda wax ka beddel",
      "birthCGCode": "Dhalashada (CG) Code",
      "groupName": "Magaca Kooxda",
      "birthSex": "Galmada Dhalmada",
      "conceptionMethod": "Habka fikradda",
      "weaningCGCode": "Koodhka naaska naaska (CG)",
      "yearlingCGCode": "Xeerka Sannadlaha (CG)",
      "dateWeight": "Taariikhda Miisaanka",
      "weaningyearlingCGcode": "Xeerka Naaska/Naaska (CG)",
      "carcassCGCode": "Koodhka bakhtiga (CG).",
      "breedOfDom": "Taranka Dam",
      "addNewContemporaryGroup": "Kudar Koox Cusub oo Casri ah",
      "createNewGroup": "Abuur Koox Cusub",
      "selectFromDifferentTraits": "Ka dooro sifooyin kala duwan",
      "contemporaryGroupName": "Magaca Kooxda Casriga ah",
      "enterNameHere": "Halkan gali magaca",
      "groupNameIsRequired": "Magaca kooxda ayaa loo baahan yahay",
      "birthYearRange": "Qiyaasta Sanadka Dhalashada",
      "theYearAnimalWasBorn": "Xoolaha sanadka ayaa dhashay",
      "birthYearIsRequired": "Sannadka dhalashada ayaa loo baahan yahay",
      "genderOfNewBornAnimal": "Jinsiga xoolaha cusub ee dhashay",
      "selectSex": "Dooro Galmo",
      "theweightOfAnimalAtBirth": "Culayska xoolaha marka uu dhasho",
      "maximumKg": "Ugu badnaan",
      "minimumKg": "Ugu yar",
      "aSeasonisAPeriodOfYear": "Xilligu waa xilli sanadka oo lagu kala saaro xaaladaha cimilada gaarka ah.",
      "seasonofBirthIsRequired": "Xilliga Dhalashada ayaa loo baahan yahay",
      "majorGenericContributionOfAnimal": "Wax ku darsiga guud ee % weyn ee xoolaha",
      "primaryBreedCompostionIsRequired": "Isku-darka taranka aasaasiga ah ayaa loo baahan yahay",
      "secondaryBreedCompostionIsRequired": "Kasbashada taranka labaad ayaa loo baahan yahay",
      "howTheAnimalWasConceived": "Sida xayawaanku u uuraystay (u-bax dabiici ah/baran/wareejin embriyaha)",
      "conceptionMethodIsRequired": "Habka fikradda ayaa loo baahan yahay",
      "epdModelSettings": "EPD Model Settings",
      "forResetMode": "Qaabka Dib u dajinta",
      "progenyWeightingFactor": "Qodobka Miisaanka Farcanka",
      "weightGivenToTheProgenyFactor": "Miisaanka la siiyay farcanka marka loo eego qodobka CG ee xisaabinta EPD ee qaabka Dib u dajinta. ",
      "enterNumber": "Geli Number",
      "enterBreed": "Gali taranka",
      "valueShouldBeBetween0and1": "Qiimuhu waa inuu u dhexeeyaa 0 iyo 1",
      "resetDuration": "Dib u dajin Mudada",
      "timeIntervalBetweenLastAndFirstResetMode": "Inta u dhaxaysa wakhtiga u dambeeya iyo habka dib u dejinta cusub, dhamaadka kaas oo habka dib u dajinta cusub la dajiyay iyo CG-yada cusub iyo EPDs ayaa la xisaabiyaa.",
      "enterNumberOfDays": "Gali tirada maalmaha",
      "valueCannotBeNegative": "Qiimaha ma noqon karo mid xun!",
      "criticalProgenyPopulation": "Dadka Faraca Xun",
      "minimumNumberOfProgenyRecords": "Tirada ugu yar ee diiwaanada farcanka ee xayawaanka gaarka ah ee nidaamka lagama maarmaanka u ah si loo gaaro saxnaanta Farcanka (APD1) ee ka sarreeya 50% (ee saxnaanta farcanka)",
      "criticalAncestorPopulation": "Dadka Awoowe Halis ah",
      "minimumNumberOfAncestorsRecords": "Tirada ugu yar ee awoowayaasha diiwaanka xayawaanka gaarka ah ee nidaamka lagama maarmaanka u ah si loo gaaro saxsanaanta Ancestor (APD4) oo ka sarreeya 50% (Saxanimada Farcanka)",
      "forBirthWeightCG": "Miisaanka Dhalashada CG",
      "criticalPopulationInAnimalsContemporaryGroup": "Dadka Halis ah ee Kooxda Casriga ah ee Xayawaanka",
      "minimumAverageNumberOfAnimalsPerBirthWeight": "Tirada celceliska ugu yar ee xoolaha halkii Dhallaankiiba CG lagama maarmaanka u ah in la gaadho Celceliska Saxnaanta CG (ACG3) ee ka sarreeya 50%",
      "criticalAveragePopulationPerContemporaryGroup": "Celceliska Dadweynaha ee Ba'an Kooxdii Casriga ahayd",
      "minimumNumberOfAnimalsInBirthWeight": "Tirada ugu yar ee xayawaanka ku jira miisaanka Dhalashada xayawaanka CG lagama maarmaanka u ah si loo gaaro saxnimada CG (ACG2) ee ka sarreeya 50%",
      "forWeaningWeightCG": "Loogu talagalay Miisaanka Naaska CG",
      "minimumAverageNumberOfAnimalsPerWeaningWeight": "Tirada celceliska ugu yar ee xoolaha halkiiba Miisaanka Goynta CG ee lagama maarmaanka u ah in la gaadho Celceliska Saxnaanta CG (ACG3) ee ka sarreeya 50%",
      "minimumNumberOfAnimalsInWeaningWeight": "Tirada ugu yar ee xoolaha ee Miisaanka Goynta Xoolaha CG lagama maarmaanka u ah si loo gaadho Saxnaanta CG (ACG2) ee ka sarreeya 50%",
      "forYearlingWeightCG": "Miisaanka Sannadlaha ah CG",
      "minimumAverageNumberOfAnimalsPerYearling": "Tirada celceliska xoolaha ee ugu yar sanadkii CG ee lagama maarmaanka u ah si loo gaaro Celceliska Saxnaanta CG (ACG3) ee ka sarreeya 50%",
      "minimumNumberOfAnimalsInYearlingWeight": "Tirada ugu yar ee xayawaanka ee Miisaanka Sannadlaha ee Xoolaha CG lagama maarmaanka u ah si loo gaaro Saxnimada CG (ACG2) ee ka sarreeya 50%",
      "forCarcassCG": "Loogu talagalay Bakhtiga CG",
      "minimumAverageNumberOfAnimalsPerCarcassWeight": "Tirada celceliska ugu yar ee xoolaha halkiiba Miisaanka Bakhtiga CG lagama maarmaanka u ah si loo gaaro Celceliska Saxnaanta CG (ACG3) ee ka sarreeya 50%",
      "minimumNumberOFAnimalInCarcassWeight": "Tirada ugu yar ee xoolaha ee Miisaanka Bakhtiga Xoolaha CG lagama maarmaanka u ah si loo gaaro Xaqiijinta CG (ACG2) ee ka sarreeya 50%",
      "epdRequiredFieldSettings": "Dejinta Goobta EPD Loo Baahan Yahay",
      "pleaseSelectRequiredFieldsForCompleteEPD": "Fadlan dooro meelaha loo baahan yahay xisaabinta EPD dhamaystiran",
      "byDefault": "By Default",
      "pleaseNoteThatUsersNotAbleToObtainFullEPD": "Fiiro gaar ah: Fadlan la soco in isticmaalayaashu aysan awoodi doonin inay helaan xisaabinta EPD oo buuxda haddii aysan bixin meelaha xogta aad calaamadisay sida loogu baahan yahay.",
      "pleaseNoteThatRequiredFieldParametersCannotBeChanged": "Fiiro gaar ah: Fadlan ogow in cabbirrada goobta loo baahan yahay aan la beddeli karin maaddaama ay horeba u jireen kooxo casri ah oo ka soo horjeeda cabbirradii hore.",
      "noResultFound": "NATIIJO LA HELIN",
      "next": "Xiga",
      "cancel": "Jooji",
      "selectAnimal": "Dooro Xayawaanka",
      "searchBy": "Ku baadh",
      "breed": "Taranka",
      "regDate": "Reg. ",
      "status": "Xaalada",
      "animalDetails": "Faahfaahinta Xoolaha",
      "add": "Ku darso",
      "update": "Cusbooneysii",
      "dataForEPDs": " Xogta EPD-yada",
      "basicInformation": "Macluumaadka aasaasiga ah",
      "birthWeightInformation": "Macluumaadka Miisaanka Dhalashada",
      "weaningWeightInformation": "Macluumaadka Miisaanka Naaska Naaska",
      "yearlingWeightInformation": "Macluumaadka Miisaanka Sannadka",
      "carcassWeightInformation": "Xogta Miisaanka Bakhtiga",
      "delete": "Tirtir",
      "deleteEpdData": "Tirtir xogta EPD",
      "areYouSureYouWantToDeleteEpdData": "Ma hubtaa inaad rabto inaad tirtirto xogta EPD.",
      "internationalID": "Aqoonsiga caalamiga ah",
      "enterID": "Geli aqoonsiga",
      "animalRegistration": "Diiwaangelinta Xoolaha",
      "location": "Goobta",
      "additionalIDMethod": "Habka Aqoonsiga Dheeraadka ah",
      "damID": "Aqoonsiga Dambiga",
      "sireID": "Aqoonsiga Sirta",
      "breederHerdCode": "Xeerka Xoolaha dhaqda",
      "birthYear": "sanadka dhalashada",
      "primaryBreed": "Asal ahaan taranka",
      "breedComposition": "Halabuurka taranka",
      "secondaryBreed": "Heerka Sare",
      "seasonofBirth": "Xiliga Dhalashada",
      "birthManagementCode": "Xeerka Maamulka Dhalashada",
      "damAge": "Da'da Dambiga",
      "years": "Sanado",
      "birthContemporaryCode": "Dhalashada Xeerka Casriga ah",
      "accuracyWeight": "Miisaanka Saxda ah",
      "note": "Ogow",
      "minimumRequiredFieldForBirthWeight": "Goobta ugu yar ee looga baahan yahay Miisaanka Dhalashada EPDs",
      "birthYearGenderConceptionMethodBirthWeight": "Sannadka Dhalashada , Jinsiga , Habka ra'yiga , Miisaanka dhalashada",
      "weaningWeight": "Miisaanka naaska naaska",
      "weaningDate": "Taariikhda naaska naaska",
      "weaningContemporaryGroupCode": "Naas-nuujinta Koodhka Kooxda Casriga ah",
      "creep": "gurguuran",
      "managementPastureCode": "Xeerka Maamulka/Daaqa",
      "weaningSex": "Galmada Naaska",
      "minimumRequiredFieldForWeaningWeight": "Meesha ugu yar ee looga baahan yahay Miisaanka Goynta EPDs",
      "weaningWeightManagementPastureCodeWeaningSexDateWeighed": "Miisaanka naaska , Maaraynta/Xeerka daaqa , Galmada naaska naaska , Taariikhda la miisaamay",
      "yearlingWeight": "Miisaanka sanadka",
      "yearlingHeight": "Dhererka Sannadlaha",
      "yearlingDate": "Taariikhda Sannadka",
      "yearlingContemporaryGroupCode": "Xeerka Kooxda Casriga ah ee Sannadlaha ah",
      "managementFeedingCode": "Xeerka Maamulka/Quudinta",
      "yearlingSex": "Galmada Sannadlaha ah",
      "youWillNeedToFillOutFor": "Waxaad u baahan doontaa inaad buuxiso dhammaan goobaha si aad ula soo baxdo xogta EPD",
      "pleaseSelectHavestDateFirstToEnterInfo": "Fadlan dooro 'Taariikhda Harvest' si aad u geliso macluumaadka Aagga Isha feeraha, Dhumucda Baruurta iyo Marbling",
      "harvestDate": "Taariikhda Goynta",
      "dateOnFeed": "Taariikhda Quudinta",
      "daysOnFeed": "Maalmaha Quudinta",
      "gradingDate": "Taariikhda Darajada",
      "carcassSex": "Galmada bakhtiga",
      "carcassWeight": "Miisaanka Bakhtiga",
      "carcassContemporary": "Bakhtiga Casriga ah",
      "damBreed": "Tarankii Dambe",
      "ribEyeArea": "Aagga isha feeraha",
      "ribEyeAreaContemporary": "Aagga Indhaha Feeraha Casriga ah",
      "fatThickness": "Dufanka Baruurta",
      "fatThicknessContemporary": "Dufanka Baruurta Casriga ah",
      "marbling": "Marbling",
      "marblingContemporary": "Marbling Casriga ah",
      "yieldGradeContemporary": "Wax-soosaarka Fasalka Casriga ah",
      "animalsNotListedInContemporaryGroupsMsg": "Xayawaanka laguma darin kooxaha casriga ah sababtuna waa macluumaadka maqan. ",
      "listOfUngroupedAnimals": "Liiska Xayawaanka Aan La Ururin",
      "submittingData": "Gudbinta Xogta",
      "resendToUser": "Dib ugu dir Isticmaalaha",
      "submittingAnimalsInGroupMsg": "U soo gudbinta xoolahaaga kooxo kooxo. ",
      "pressingResetBtnMsg": "Marka la riixo badhanka \"Dib u dajinta\" waxay bilaabi doontaa hab dib loogu meeleeyo xoolaha kooxahooda casriga ah.",
      "doYouWantToProceed": "Ma rabtaa inaad sii wadato?",
      "systemMaintainanceModeMsg": "Riixitaanka \"Beddelka Qaabka Dayactirka\" badhanka wuxuu bilaabi doonaa habsocodka oo nidaamkaagu wuxuu geli doonaa \"MAINTENANCE MODE\" halkaas oo EDPs lagu xisaabiyo RESET lagu hayn doono si joogto ah xayawaan kasta ilaa dib u habeynta soo socota (oo noqon karta 1-6 bilood ",
      "errorFetchingContemporaryGrpMsg": "Khalad keenida xogta kooxda casriga ah",
      "deleteSuccess": "Tirtir Guusha",
      "deleteSuccessMsg": "Kooxda casriga ah ayaa si guul leh loo tirtiray",
      "deleteFailed": "Tirtiridda Waa Fashilmay",
      "deleteFailedMsg": "Khalad tirtirida xogta kooxda casriga ah",
      "deleteContemporaryGrpMsg": "Ma hubtaa inaad doonayso inaad tirtirto kooxdan casriga ah?",
      "addBirthWeightData": "Ku dar Xogta Miisaanka Dhalashada",
      "addWeaningWeightData": "Ku dar Xogta Miisaanka Naaska",
      "birthWeightContemporaryGroupCode": "Xeerka Kooxda Casriga ah ee Miisaanka Dhalashada",
      "dateWeighted": "Taariikhda La Miisaamay",
      "addYearlingWeightData": "Kudar Xogta Miisaanka Sannadka",
      "addCarcassWeightData": "Kudar Xogta Miisaanka Bakhtiga",
      "weaningOrYearlingContemporaryGroupCode": "Koodhka Kooxda Casriga ah ee Naas-nuujinta ama Culayska Sannadka",
      "deleteContemporaryGroupMsg": "Ma hubtaa inaad rabto inaad tirtirto kooxda casriga ah?",
      "updateSuccessMsg": "Kooxda casriga ah si guul leh ayaa loo cusboonaysiiyay",
      "errorMsg": "Waxbaa qaldamay. ",
      "fetchErrorMsg": "Khalad keenista goobaha loo baahan yahay sifada la xushay",
      "forMaintainanceMode": "Qaabka Dayactirka",
      "ancestorsWeightFactor": "Qodobka Miisaanka Awoowayaasha",
      "weightGivenToTheAncestorFactor": "Miisaanka la siiyay qodobka awoowaha marka loo eego CG factor ee xisaabinta EPD ee qaabka dayactirka. ",
      "addEPDModelSettingsData": "Ku dar xogta Settings Model EPD",
      "minimumNumberOfAnimalsInContemporaryGroups": "Tirada ugu yar ee Xayawaanka ee Kooxaha Casriga ah",
      "enterNumberOfAnimals": "Geli Tirada Xoolaha",
      "areYouSureYouWantToChangeEPDCalculation": "Ma hubtaa inaad rabto inaad beddesho meelaha xisaabinta EPD ee loo baahan yahay?",
      "weightOfAnimalAtBirth": "Miisaanka Xoolaha marka ay Dhashay",
      "seasonIsAPeriodOfYear": "Xilligu waa xilli sanadka oo lagu kala saaro xaaladaha cimilada gaarka ah.",
      "codeOfBirthWeightContemporaryGroup": "Xeerka Kooxda Casriga ah ee Miisaanka Dhalashada",
      "weaningWeightOfCalf": "Miisaanka Naaska ee dibiga",
      "dateAnimalWasWeaned": "Taariikhda neefka naaska laga jaray",
      "genderOfWeaningAnimal": "Jinsiga Xoolaha Naaska",
      "yearlingWeightOfCalf": "Miisaanka Kubka Sannadka",
      "dateAnimalWasWeighted": "Taariikhda neefka la miisaamay",
      "yearledAnimalSex": "Galmada neefka oo la gubo",
      "dateOfAnimalKilledForMeat": "Taariikhda xoolaha lagu dilay hilibka",
      "addSuccessMsg": "Kooxda casriga ah ayaa lagu daray si guul leh",
      "traitH": "Sifada xisaabinta EPD.",
      "searchByValue": "Geli Diiwaangelinta Maya/Tattoo/Magac/Tag"
    }
  }